webpackJsonp([35],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/X7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "13Mj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/@material/textfield/foundation.js + 2 modules
var foundation = __webpack_require__("+5df");

// EXTERNAL MODULE: ./node_modules/vue-mdc-adapter/components/util/index.js + 8 modules
var util = __webpack_require__("t+Kx");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-mdc-adapter/components/textfield/mdc-textfield.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var mdc_textfield = ({
  name: 'mdc-textfield',
  props: {
    'value': String,
    'type': {
      type: String,
      default: 'text',
      validator: function validator(value) {
        return ['text', 'email', 'search', 'password', 'tel', 'url'].includes(value);
      }
    },
    'dense': Boolean,
    'label': String,
    'helptext': String,
    'helptext-persistent': Boolean,
    'helptext-validation': Boolean,
    'disabled': Boolean,
    'required': Boolean,
    'minlength': { type: [Number, String], default: undefined },
    'maxlength': { type: [Number, String], default: undefined },
    'size': { type: [Number, String], default: 20 },
    'fullwidth': Boolean,
    'multiline': Boolean,
    'rows': { type: [Number, String], default: 8 },
    'cols': { type: [Number, String], default: 40 }
  },
  data: function data() {
    return {
      text: this.value,
      rootClasses: {
        'mdc-text-field': true,
        'mdc-text-field--upgraded': true,
        'mdc-text-field--disabled': this.disabled,
        'mdc-text-field--dense': this.dense,
        'mdc-text-field--fullwidth': this.fullwidth,
        'mdc-text-field--textarea': this.multiline
      },
      inputClasses: {
        'mdc-text-field__input': true
      },
      labelClasses: {
        'mdc-text-field__label': true
      },
      bottomClasses: {
        'mdc-text-field__bottom-line': true
      },
      helpClasses: {
        'mdc-text-field-helptext': true,
        'mdc-text-field-helptext--persistent': this.helptextPersistent,
        'mdc-text-field-helptext--validation-msg': this.helptextValidation
      }
    };
  },
  watch: {
    disabled: function disabled() {
      this.foundation && this.foundation.setDisabled(this.disabled);
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },
  computed: {
    labelClassesUpgraded: function labelClassesUpgraded() {
      return assign_default()(this.labelClasses, {
        'mdc-text-field__label--float-above': this.value
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.foundation = new foundation["a" /* default */]({
      addClass: function addClass(className) {
        _this.$set(_this.rootClasses, className, true);
      },
      removeClass: function removeClass(className) {
        _this.$delete(_this.rootClasses, className);
      },
      addClassToLabel: function addClassToLabel(className) {
        _this.$set(_this.labelClasses, className, true);
      },
      removeClassFromLabel: function removeClassFromLabel(className) {
        _this.$delete(_this.labelClasses, className);
      },
      setIconAttr: function setIconAttr() /* name: string, value: string */{},
      eventTargetHasClass: function eventTargetHasClass(target, className) {
        return target.classList.contains(className);
      },
      registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler(evtType, handler) {
        _this.$refs.root.addEventListener(evtType, handler);
      },
      deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler(evtType, handler) {
        _this.$refs.root.removeEventListener(evtType, handler);
      },
      addClassToBottomLine: function addClassToBottomLine(className) {
        _this.$set(_this.bottomClasses, className, true);
      },
      removeClassFromBottomLine: function removeClassFromBottomLine(className) {
        _this.$delete(_this.bottomClasses, className);
      },
      addClassToHelptext: function addClassToHelptext(className) {
        _this.$set(_this.helpClasses, className, true);
      },
      removeClassFromHelptext: function removeClassFromHelptext(className) {
        _this.$delete(_this.helpClasses, className);
      },
      helptextHasClass: function helptextHasClass(className) {
        return _this.$refs.help && _this.$refs.help.classList.contains(className);
      },
      registerInputInteractionHandler: function registerInputInteractionHandler(evtType, handler) {
        _this.$refs.input.addEventListener(evtType, handler);
      },
      deregisterInputInteractionHandler: function deregisterInputInteractionHandler(evtType, handler) {
        _this.$refs.input.removeEventListener(evtType, handler);
      },
      registerTransitionEndHandler: function registerTransitionEndHandler(handler) {
        if (_this.$refs.bottom) {
          _this.$refs.bottom.addEventListener('transitionend', handler);
        }
      },
      deregisterTransitionEndHandler: function deregisterTransitionEndHandler(handler) {
        if (_this.$refs.bottom) {
          _this.$refs.bottom.removeEventListener('transitionend', handler);
        }
      },
      setBottomLineAttr: function setBottomLineAttr(name, value) {
        if (_this.$refs.bottom) {
          _this.$refs.bottom.setAttribute(name, value);
        }
      },
      setHelptextAttr: function setHelptextAttr(name, value) {
        if (_this.$refs.help) {
          _this.$refs.help.setAttribute(name, value);
        }
      },
      removeHelptextAttr: function removeHelptextAttr(name) {
        if (_this.$refs.help) {
          _this.$refs.help.removeAttribute(name);
        }
      },
      getNativeInput: function getNativeInput() {
        return _this.$refs.input;
      },
      notifyIconAction: function notifyIconAction() {
        _this.$emit('icon');
      }
    });
    this.foundation.init();
    this.foundation.setDisabled(this.disabled);

    if (this.textbox) {
      this.ripple = new util["a" /* RippleBase */](this);
      this.ripple.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.foundation.destroy();
    if (this.ripple) {
      this.ripple.destroy();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1fb0ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-mdc-adapter/components/textfield/mdc-textfield.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.multiline && _vm.fullwidth)?_c('div',{ref:"root",class:_vm.rootClasses},[_c('textarea',{ref:"input",class:_vm.inputClasses,attrs:{"rows":_vm.rows,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"aria-controls":'help-'+_vm._uid,"placeholder":_vm.label,"aria-label":_vm.label},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}},[_vm._v("      >")])]):(_vm.multiline)?_c('div',{ref:"root",class:_vm.rootClasses},[_c('textarea',{ref:"input",class:_vm.inputClasses,attrs:{"id":_vm._uid,"rows":_vm.rows,"cols":_vm.cols,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"aria-controls":'help-'+_vm._uid},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}}),_vm._v(" "),(_vm.label)?_c('label',{ref:"label",class:_vm.labelClassesUpgraded,attrs:{"for":_vm._uid}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]):(_vm.fullwidth)?_c('div',{ref:"root",class:_vm.rootClasses},[_c('input',{ref:"input",class:_vm.inputClasses,attrs:{"type":_vm.type,"required":_vm.required,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"aria-controls":'help-'+_vm._uid,"placeholder":_vm.label,"aria-label":_vm.label},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})]):_c('div',{ref:"root",class:_vm.rootClasses},[_c('input',{ref:"input",class:_vm.inputClasses,attrs:{"type":_vm.type,"id":_vm._uid,"required":_vm.required,"size":_vm.size,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"aria-controls":'help-'+_vm._uid},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}}),_vm._v(" "),(_vm.label)?_c('label',{ref:"label",class:_vm.labelClassesUpgraded,attrs:{"for":_vm._uid}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{ref:"bottom",class:_vm.bottomClasses})]),_vm._v(" "),(_vm.helptext)?_c('p',{ref:"help",class:_vm.helpClasses,attrs:{"id":'help-'+_vm._uid,"aria-hidden":"true"}},[_vm._v("\n    "+_vm._s(_vm.helptext)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var textfield_mdc_textfield = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-mdc-adapter/components/textfield/mdc-textfield.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  mdc_textfield,
  textfield_mdc_textfield,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_textfield_mdc_textfield = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "14gb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * event bus
 */

var minibus = __webpack_require__("jpXo");
var observers = {};

minibus.extension.subscribe = function (observer, trigger, handler) {
  var route = this.on(trigger, handler);(observers[observer._uid] = observers[observer._uid] || []).push(route);
};

minibus.extension.leave = function (observer) {
  var _this = this;

  if (!observers[observer._uid]) return;
  observers[observer._uid].map(function (route) {
    return _this.off(route);
  });
  delete observers[observer._uid];
};

var bus = minibus.create();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ "1etf":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.json": "tdkq",
	"./en.json": "NuBg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1etf";

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "F+RQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FUtQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JD12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JicR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tuple", function() { return tuple; });
// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var UniversalWeakMap = function UniversalWeakMap() {
  // Since a `WeakMap` cannot hold primitive values as keys, we need a
  // backup `Map` instance to hold primitive keys. Both `this._weakMap`
  // and `this._strongMap` are lazily initialized.
  this._weakMap = null;
  this._strongMap = null;
};

// Since `get` and `set` are the only methods used, that's all I've
// implemented here.

UniversalWeakMap.prototype.get = function get (key) {
  var map = this._getMap(key, false);
  if (map) {
    return map.get(key);
  }
};

UniversalWeakMap.prototype.set = function set (key, value) {
  this._getMap(key, true).set(key, value);
  // An actual `Map` or `WeakMap` would return `this` here, but
  // returning the `value` is more convenient for the `tuple`
  // implementation.
  return value;
};

UniversalWeakMap.prototype._getMap = function _getMap (key, canCreate) {
  if (! canCreate) {
    return isObjRef(key) ? this._weakMap : this._strongMap;
  }
  if (isObjRef(key)) {
    return this._weakMap || (this._weakMap = new WeakMap);
  }
  return this._strongMap || (this._strongMap = new Map);
};

function isObjRef(value) {
  switch (typeof value) {
  case "object":
    if (value === null) {
      return false;
    }
  case "function":
    return true;
  default:
    return false;
  }
}

// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var useSymbol = typeof Symbol === "function";

// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var brand = useSymbol
  ? Symbol.for("immutable-tuple")
  : "@@__IMMUTABLE_TUPLE__@@";

// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var globalKey = useSymbol
  ? Symbol.for("immutable-tuple-root")
  : "@@__IMMUTABLE_TUPLE_ROOT__@@";

// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function forEachArrayMethod(fn) {
  function call(name, mustConvertThisToArray) {
    var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
    fn(name, desc, !! mustConvertThisToArray);
  }

  call("every");
  call("filter");
  call("find");
  call("findIndex");
  call("forEach");
  call("includes");
  call("indexOf");
  call("join");
  call("lastIndexOf");
  call("map");
  call("reduce");
  call("reduceRight");
  call("slice");
  call("some");
  call("toLocaleString");
  call("toString");

  // The `reverse` and `sort` methods are usually destructive, but for
  // `tuple` objects they return a new `tuple` object that has been
  // appropriately reversed/sorted.
  call("reverse", true);
  call("sort", true);

  // Make `[...someTuple]` work.
  call(useSymbol && Symbol.iterator || "@@iterator");
}

// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function tuple() {
  var items = [], len = arguments.length;
  while ( len-- ) items[ len ] = arguments[ len ];

  return intern(items);
}

// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var root = globalKey in Array
  ? Array[globalKey]
  : def(Array, globalKey, new UniversalWeakMap, false);

function intern(array) {
  var node = root;

  // Because we are building a tree of *weak* maps, the tree will not
  // prevent objects in tuples from being garbage collected, since the
  // tree itself will be pruned over time when the corresponding `tuple`
  // objects become unreachable. In addition to internalization, this
  // property is a key advantage of the `immutable-tuple` package.
  array.forEach(function (item) {
    node = node.get(item) || node.set(item, new UniversalWeakMap);
  });

  // If a `tuple` object has already been created for exactly these items,
  // return that object again.
  if (node.tuple) {
    return node.tuple;
  }

  var t = Object.create(tuple.prototype);

  // Define immutable items with numeric indexes, and permanently fix the
  // `.length` property.
  array.forEach(function (item, i) { return def(t, i, item, true); });
  def(t, "length", array.length, false);

  // Remember this new `tuple` object so that we can return the same object
  // earlier next time.
  return node.tuple = t;
}

// Convenient helper for defining hidden immutable properties.
function def(obj, name, value, enumerable) {
  Object.defineProperty(obj, name, {
    value: value,
    enumerable: !! enumerable,
    writable: false,
    configurable: false
  });
  return value;
}

// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
function isTuple(that) {
  return !! (that && that[brand] === true);
}

def(tuple.prototype, brand, true, false);

tuple.isTuple = isTuple;

function toArray(tuple) {
  var array = [];
  var i = tuple.length;
  while (i--) { array[i] = tuple[i]; }
  return array;
}

// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
forEachArrayMethod(function (name, desc, mustConvertThisToArray) {
  var method = desc && desc.value;
  if (typeof method === "function") {
    desc.value = function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = method.apply(
        mustConvertThisToArray ? toArray(this) : this,
        args
      );
      // Of course, `tuple.prototype.slice` should return a `tuple` object,
      // not a new `Array`.
      return Array.isArray(result) ? intern(result) : result;
    };
    Object.defineProperty(tuple.prototype, name, desc);
  }
});

// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var ref = Array.prototype;
var concat = ref.concat;
tuple.prototype.concat = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return intern(concat.apply(toArray(this), args.map(
    function (item) { return isTuple(item) ? toArray(item) : item; }
  )));
};

/* harmony default export */ __webpack_exports__["default"] = (tuple);



/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/Users/charan/projects/getcloser/myprofile"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/Users/charan/projects/getcloser/myprofile","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "MuD1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/element-ui/lib/tab-pane.js
var tab_pane = __webpack_require__("LaeV");
var tab_pane_default = /*#__PURE__*/__webpack_require__.n(tab_pane);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/tabs.js
var tabs = __webpack_require__("NoPp");
var tabs_default = /*#__PURE__*/__webpack_require__.n(tabs);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table-column.js
var table_column = __webpack_require__("q4le");
var table_column_default = /*#__PURE__*/__webpack_require__.n(table_column);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/table.js
var table = __webpack_require__("LR6y");
var table_default = /*#__PURE__*/__webpack_require__.n(table);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/form-item.js
var form_item = __webpack_require__("Mezo");
var form_item_default = /*#__PURE__*/__webpack_require__.n(form_item);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/form.js
var lib_form = __webpack_require__("vqwl");
var form_default = /*#__PURE__*/__webpack_require__.n(lib_form);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/progress.js
var progress = __webpack_require__("GegP");
var progress_default = /*#__PURE__*/__webpack_require__.n(progress);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/upload.js
var upload = __webpack_require__("wOhx");
var upload_default = /*#__PURE__*/__webpack_require__.n(upload);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/switch.js
var lib_switch = __webpack_require__("wxbk");
var switch_default = /*#__PURE__*/__webpack_require__.n(lib_switch);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/dialog.js
var dialog = __webpack_require__("qubY");
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/dropdown-item.js
var dropdown_item = __webpack_require__("BrEC");
var dropdown_item_default = /*#__PURE__*/__webpack_require__.n(dropdown_item);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/dropdown-menu.js
var dropdown_menu = __webpack_require__("+nRk");
var dropdown_menu_default = /*#__PURE__*/__webpack_require__.n(dropdown_menu);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/dropdown.js
var dropdown = __webpack_require__("o6kb");
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/button.js
var lib_button = __webpack_require__("mtrD");
var button_default = /*#__PURE__*/__webpack_require__.n(lib_button);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/input-number.js
var input_number = __webpack_require__("0kY3");
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/checkbox-group.js
var checkbox_group = __webpack_require__("s3ue");
var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/checkbox-button.js
var checkbox_button = __webpack_require__("L6k1");
var checkbox_button_default = /*#__PURE__*/__webpack_require__.n(checkbox_button);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/checkbox.js
var lib_checkbox = __webpack_require__("EKTV");
var checkbox_default = /*#__PURE__*/__webpack_require__.n(lib_checkbox);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/time-picker.js
var time_picker = __webpack_require__("4ZDJ");
var time_picker_default = /*#__PURE__*/__webpack_require__.n(time_picker);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/time-select.js
var time_select = __webpack_require__("bFD8");
var time_select_default = /*#__PURE__*/__webpack_require__.n(time_select);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/date-picker.js
var date_picker = __webpack_require__("tLa+");
var date_picker_default = /*#__PURE__*/__webpack_require__.n(date_picker);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/option.js
var lib_option = __webpack_require__("STLj");
var option_default = /*#__PURE__*/__webpack_require__.n(lib_option);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/select.js
var lib_select = __webpack_require__("e0Bm");
var select_default = /*#__PURE__*/__webpack_require__.n(lib_select);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/pagination.js
var pagination = __webpack_require__("6oiW");
var pagination_default = /*#__PURE__*/__webpack_require__.n(pagination);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/alert.js
var lib_alert = __webpack_require__("D3wm");
var alert_default = /*#__PURE__*/__webpack_require__.n(lib_alert);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./node_modules/vue-shortkey/dist/index.js
var dist = __webpack_require__("m0IH");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-sticky/dist/vue-sticky.js
var vue_sticky = __webpack_require__("e45v");
var vue_sticky_default = /*#__PURE__*/__webpack_require__.n(vue_sticky);

// EXTERNAL MODULE: ./node_modules/vue-mdc-adapter/components/textfield/index.js + 1 modules
var textfield = __webpack_require__("vpcK");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/message.js
var lib_message = __webpack_require__("2X9z");
var message_default = /*#__PURE__*/__webpack_require__.n(lib_message);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/lib/api.js




var api__this = this;




/**
 * initialize HTTPClient
 */
var api_HTTP = axios_default.a.create({
  baseURL: "/api/private/",
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 500;
  }
});

/**
 * resign new requests with current auth token
 */
api_HTTP.interceptors.request.use(function (config) {
  // if (cookie) config.headers['Cookie'] = cookie
  return config;
});

var api_showError = function showError(msg) {
  message_default()({
    message: msg,
    type: 'error',
    duration: 3500,
    showClose: true
  });
};

/**
 * error handling
 */
var api_onError = function onError(e) {
  console.error('API HTTP Error', e);
  api_showError('An unknown error occured');
};

var onResponseError = function onResponseError(response) {
  if (response.status === 401) {
    return api_showError(response.data.message || 'Authentication Error');
  }
  if (response.status === 403) {
    return api_showError(response.data.message || 'Authentication Error');
  }
  if (response.status >= 400) {
    return api_showError(response.data.message || 'An unknown error occured');
  }
};

/**
 * generic request
 */
var api_request = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(method, url, data, params, cookie) {
    var headers, response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            console.log('[API]', { method: method, url: url, data: data, params: params, cookie: cookie });
            headers = null;

            if (cookie) headers = { Cookie: cookie };
            _context.next = 6;
            return api_HTTP.request({ method: method, url: url, data: data, params: params, headers: headers });

          case 6:
            response = _context.sent;

            if (!(response.status < 300)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', response.data);

          case 9:
            onResponseError(response);
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](0);

            api_onError(_context.t0);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, api__this, [[0, 12]]);
  }));

  return function request(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var api = ({
  methods: {
    /**
     * expose api[Post|Get|etc.]
     */
    apiPost: function apiPost(url, data) {
      return api_request('post', url, data);
    },
    apiPut: function apiPut(url, data) {
      return api_request('put', url, data);
    },
    apiGet: function apiGet(url, params, cookie) {
      return api_request('get', url, null, params, cookie);
    },
    apiDelete: function apiDelete(url) {
      return api_request('delete', url);
    }
  }
});
// CONCATENATED MODULE: ./src/lib/validation.js





var validation__this = this;



var isUniqueEmail = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(value, _ref2) {
    var _ref3 = slicedToArray_default()(_ref2, 1),
        currentEmail = _ref3[0];

    var valid, response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            valid = false;

            if (!(currentEmail && value === currentEmail)) {
              _context.next = 5;
              break;
            }

            valid = true;
            _context.next = 9;
            break;

          case 5:
            _context.next = 7;
            return api.methods.apiPost('validate/email', {
              email: value
            });

          case 7:
            response = _context.sent;

            valid = response.valid;

          case 9:
            return _context.abrupt('return', {
              valid: valid
            });

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, validation__this);
  }));

  return function isUniqueEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var isUniqueNick = function () {
  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(value, _ref5) {
    var _ref6 = slicedToArray_default()(_ref5, 1),
        currentNickname = _ref6[0];

    var valid, response;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            valid = false;

            if (!(currentNickname && value === currentNickname)) {
              _context2.next = 5;
              break;
            }

            valid = true;
            _context2.next = 9;
            break;

          case 5:
            _context2.next = 7;
            return api.methods.apiPost('validate/nickname', {
              nickname: value
            });

          case 7:
            response = _context2.sent;

            valid = response.valid;

          case 9:
            return _context2.abrupt('return', {
              valid: valid
            });

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, validation__this);
  }));

  return function isUniqueNick(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

var isUniqueRewardLevel = function () {
  var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(value, _ref8) {
    var _ref9 = slicedToArray_default()(_ref8, 1),
        rewardId = _ref9[0];

    var valid, response;
    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            valid = false;
            _context3.next = 3;
            return api.methods.apiPost('validate/rewardLevel', {
              amount: value * 100,
              rewardId: rewardId
            });

          case 3:
            response = _context3.sent;

            valid = response.valid;
            return _context3.abrupt('return', {
              valid: valid
            });

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, validation__this);
  }));

  return function isUniqueRewardLevel(_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();

var rules = {
  'uniqueEmail': {
    validate: isUniqueEmail,
    getMessage: function getMessage() {
      return 'This Email is already taken.';
    }
  },
  'uniqueNickname': {
    validate: isUniqueNick,
    getMessage: function getMessage() {
      return 'The nickname is already taken.';
    }
  },
  'isUniqueRewardLevel': {
    validate: isUniqueRewardLevel,
    getMessage: function getMessage() {
      return 'Dear Star, this reward already exists. Please choose a different amount.';
    }
  }
  // export an 'install' function.
};/* harmony default export */ var validation = (function (VeeValidate) {
  // Failed to add this rule to the above structure.
  // Passing data did not work.
  var isPasswordStrong = function () {
    var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(value) {
      var response;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api.methods.apiPost('validate/password', {
                password: value
              });

            case 2:
              response = _context4.sent;
              return _context4.abrupt('return', {
                valid: response.valid,
                data: {
                  message: response.feedback.warning || 'Password is too weak.',
                  feedback: response.feedback,
                  score: response.score
                }
              });

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, validation__this);
    }));

    return function isPasswordStrong(_x7) {
      return _ref10.apply(this, arguments);
    };
  }();

  VeeValidate.Validator.extend('passwordStrength', {
    validate: isPasswordStrong,
    getMessage: function getMessage(field, params, data) {
      if (data) {
        return {
          message: data.message,
          feedback: data.feedback,
          score: data.score
        };
      }
    }
  });

  // for every rule we defined above.
  keys_default()(rules).forEach(function (rule) {
    //  add the rule.
    VeeValidate.Validator.extend(rule, rules[rule]);
  });
});
// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/en.js
var en = __webpack_require__("wUZ8");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/index.js
var lib_locale = __webpack_require__("urW8");
var locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale);

// EXTERNAL MODULE: ./node_modules/vue-flag-icon/index.js + 2 modules
var vue_flag_icon = __webpack_require__("StEu");

// EXTERNAL MODULE: ./node_modules/vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("wvfG");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// EXTERNAL MODULE: ./node_modules/vue-apexcharts/dist/vue-apexcharts.js
var vue_apexcharts = __webpack_require__("HJCm");
var vue_apexcharts_default = /*#__PURE__*/__webpack_require__.n(vue_apexcharts);

// EXTERNAL MODULE: ./node_modules/vue-mq/dist/vue-mq.es.js
var vue_mq_es = __webpack_require__("iKms");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/searchbar.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var searchbar = ({
  props: ['name', 'params', 'disabled'],

  created: function created() {
    var _this = this;

    this.$eventBus.$on('logout', function (options) {
      _this.doLogout(options);
    });
  },
  mounted: function mounted() {
    this.$root.$on('sidebarclose', this.toggleMenuButton);
  },

  computed: extends_default()({
    assets: function assets() {
      return "/myprofile/static" || '/static';
    }
  }, Object(vuex_esm["c" /* mapState */])(['user'])),
  methods: extends_default()({
    toggleMenuButton: function toggleMenuButton() {
      this.$refs.menubutton.classList.toggle('active');
    },
    flide: function flide() {
      this.$root.$emit('flide');
      this.toggleMenuButton();
    },
    doLogout: function doLogout(options) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.apiGet('logout', null, false);

              case 2:
                data = _context.sent;

                if (data) {
                  _this2.logout();
                  if (!options || !options.localStorageSignal) {
                    window.localStorage.setItem('logoutTime', '' + Date.now());
                  }
                  window.location.href = '/';
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }, Object(vuex_esm["b" /* mapActions */])(['logout'])),
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('sidebarclose', this.toggleMenuButton);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321a399c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchbar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_c('nav',{staticClass:"navbar is-subnavtop is-shadowed",attrs:{"id":"subnavtop"}},[_c('div',{ref:"menubutton",staticClass:"burger is-pulled-right",on:{"click":function($event){return _vm.flide()}}},[_c('span',{staticClass:"upper"}),_vm._v(" "),_c('span',{staticClass:"middle"}),_vm._v(" "),_c('span',{staticClass:"bottom"})]),_vm._v(" "),_c('div',{staticClass:"navbar-menu"},[_c('a',{staticClass:"nav-item nav-brand no-text",attrs:{"href":"/"}},[_c('span',{staticClass:"logo-wrapper"},[_c('img',{attrs:{"src":(_vm.assets + "/img/logo_getcloser_25_11_18_3.svg")}})])]),_vm._v(" "),_c('div',{staticClass:"navbar-item is-expanded is-paddingless is-hidden-touch"}),_vm._v(" "),_c('router-link',{staticClass:"is-hidden-touch navbar-item is-tab",attrs:{"id":"accountLink","to":{ name: 'accountEdit'},"active-class":"is-active"}},[_vm._v("\n        Hi, "+_vm._s(_vm.user.nickname)+"\n      ")]),_vm._v(" "),_c('a',{staticClass:"is-hidden-touch navbar-item is-tab",attrs:{"id":"logoutLink"},on:{"click":function($event){$event.preventDefault();return _vm.doLogout.apply(null, arguments)}}},[_vm._v("\n      Log out")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_searchbar = (esExports);
// CONCATENATED MODULE: ./src/components/searchbar.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  searchbar,
  components_searchbar,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_searchbar = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sortable.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var sortable = ({
  props: ['name', 'field', 'params'],
  computed: {
    icon: function icon() {
      if (this.field === this.params.sort) {
        return this.params.direction === '1' ? 'keyboard_arrow_down' : 'keyboard_arrow_up';
      }
      return false;
    }
  },
  methods: {
    changeSort: function changeSort() {
      if (this.field === this.params.sort) {
        this.params.direction = this.params.direction === '1' ? '-1' : '1';
        this.$emit('change', this.params);
      } else {
        this.params.sort = this.field;
        this.$emit('change', this.params);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a6499c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sortable.vue
var sortable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sortable",on:{"click":_vm.changeSort}},[_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"icon is-medium"},[_c('i',{staticClass:"material-icons md-24"},[_vm._v(_vm._s(_vm.icon))])])])}
var sortable_staticRenderFns = []
var sortable_esExports = { render: sortable_render, staticRenderFns: sortable_staticRenderFns }
/* harmony default export */ var components_sortable = (sortable_esExports);
// CONCATENATED MODULE: ./src/components/sortable.vue
var sortable_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var sortable___vue_template_functional__ = false
/* styles */
var sortable___vue_styles__ = null
/* scopeId */
var sortable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sortable___vue_module_identifier__ = null
var sortable_Component = sortable_normalizeComponent(
  sortable,
  components_sortable,
  sortable___vue_template_functional__,
  sortable___vue_styles__,
  sortable___vue_scopeId__,
  sortable___vue_module_identifier__
)

/* harmony default export */ var src_components_sortable = (sortable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/input-error.vue
//
//
//
//
//

/* harmony default export */ var input_error = ({
  props: ['name'],
  inject: ['$validator']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475a0b7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-error.vue
var input_error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.has(_vm.name))?_c('span',{staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first(_vm.name)))]):_vm._e()}
var input_error_staticRenderFns = []
var input_error_esExports = { render: input_error_render, staticRenderFns: input_error_staticRenderFns }
/* harmony default export */ var components_input_error = (input_error_esExports);
// CONCATENATED MODULE: ./src/components/input-error.vue
var input_error_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var input_error___vue_template_functional__ = false
/* styles */
var input_error___vue_styles__ = null
/* scopeId */
var input_error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var input_error___vue_module_identifier__ = null
var input_error_Component = input_error_normalizeComponent(
  input_error,
  components_input_error,
  input_error___vue_template_functional__,
  input_error___vue_styles__,
  input_error___vue_scopeId__,
  input_error___vue_module_identifier__
)

/* harmony default export */ var src_components_input_error = (input_error_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/input-text.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var input_text = ({
  props: ['name', 'value', 'label', 'validate', 'type', 'disabled'],
  inject: ['$validator'],
  computed: {
    myName: function myName() {
      return this.name || this.label;
    },
    validation: function validation() {
      return this.validate || false;
    },
    isRequired: function isRequired() {
      return this.validate && this.validate.indexOf('required') > -1;
    }
  },
  methods: {
    updateModel: function updateModel(value) {
      this.$emit('input', value);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-510b3106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-text.vue
var input_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mdc-textfield',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validation),expression:"validation"}],class:{required: _vm.isRequired, 'is-danger': _vm.errors.has(_vm.myName) },attrs:{"value":_vm.value,"label":_vm.label,"name":_vm.myName,"type":_vm.type,"disabled":_vm.disabled},on:{"input":_vm.updateModel}}),_vm._v(" "),_c('input-error',{attrs:{"name":_vm.myName}})],1)}
var input_text_staticRenderFns = []
var input_text_esExports = { render: input_text_render, staticRenderFns: input_text_staticRenderFns }
/* harmony default export */ var components_input_text = (input_text_esExports);
// CONCATENATED MODULE: ./src/components/input-text.vue
var input_text_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var input_text___vue_template_functional__ = false
/* styles */
var input_text___vue_styles__ = null
/* scopeId */
var input_text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var input_text___vue_module_identifier__ = null
var input_text_Component = input_text_normalizeComponent(
  input_text,
  components_input_text,
  input_text___vue_template_functional__,
  input_text___vue_styles__,
  input_text___vue_scopeId__,
  input_text___vue_module_identifier__
)

/* harmony default export */ var src_components_input_text = (input_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f49908f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainfooter.vue
var mainfooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var mainfooter_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('h4',{staticClass:"title is-4"},[_vm._v("About getnext.to")]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"has-text-grey-light"},[_vm._v("\n            getnext.to offers a subscription-based platform where fans can get exclusive access to their stars, enabling a new level of relationship and interaction.\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Help Center & FAQs")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_vm._v("Terms of Use")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_vm._v("Privacy Policy")]),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/"}},[_vm._v("About")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_vm._v("Blog")]),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"/nena"}},[_vm._v("Nena")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/blutengel"}},[_vm._v("Blutengel")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"/fewjar"}},[_vm._v("Fewjar")]),_c('br')])])]),_vm._v(" "),_c('nav',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item is-size-7"},[_vm._v("© 2025 Fans & Fortune GmbH")])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item is-size-7"})])])])])}]
var mainfooter_esExports = { render: mainfooter_render, staticRenderFns: mainfooter_staticRenderFns }
/* harmony default export */ var mainfooter = (mainfooter_esExports);
// CONCATENATED MODULE: ./src/components/mainfooter.vue
var mainfooter_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var mainfooter___vue_template_functional__ = false
/* styles */
var mainfooter___vue_styles__ = null
/* scopeId */
var mainfooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainfooter___vue_module_identifier__ = null
var mainfooter_Component = mainfooter_normalizeComponent(
  __vue_script__,
  mainfooter,
  mainfooter___vue_template_functional__,
  mainfooter___vue_styles__,
  mainfooter___vue_scopeId__,
  mainfooter___vue_module_identifier__
)

/* harmony default export */ var components_mainfooter = (mainfooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mainnav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var mainnav = ({
  computed: {
    assets: function assets() {
      return "/myprofile/static" || '/static';
    }
  },
  mounted: function mounted() {
    var mainnav = this.$refs.mainnav;
    window.onscroll = function () {
      var offset = window.pageYOffset;
      if (offset <= 0) mainnav.classList.remove('js-is-sticky');
      if (offset > 0) mainnav.classList.add('js-is-sticky');
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a97372e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainnav.vue
var mainnav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{directives:[{name:"sticky",rawName:"v-sticky",value:({ zIndex: 1, stickyTop: 0 }),expression:"{ zIndex: 1, stickyTop: 0 }"}],ref:"mainnav",staticClass:"navbar is-transparent",attrs:{"id":"mainnav"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-menu"},[_c('div',{staticClass:"navbar-start"},[_c('a',{staticClass:"nav-item nav-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":(_vm.assets + "/img/logo_getcloser_25_11_18_3.svg")}})])]),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('router-link',{staticClass:"navbar-item is-tab",attrs:{"active-class":"is-active","to":{ path: 'signup' }}},[_vm._v(_vm._s(_vm.$t('navigation.signup')))]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item is-tab",attrs:{"active-class":"is-active","to":{ path: 'login' }}},[_vm._v(_vm._s(_vm.$t('navigation.login')))])],1)])])])}
var mainnav_staticRenderFns = []
var mainnav_esExports = { render: mainnav_render, staticRenderFns: mainnav_staticRenderFns }
/* harmony default export */ var components_mainnav = (mainnav_esExports);
// CONCATENATED MODULE: ./src/components/mainnav.vue
function injectStyle (ssrContext) {
  __webpack_require__("FUtQ")
}
var mainnav_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var mainnav___vue_template_functional__ = false
/* styles */
var mainnav___vue_styles__ = injectStyle
/* scopeId */
var mainnav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mainnav___vue_module_identifier__ = null
var mainnav_Component = mainnav_normalizeComponent(
  mainnav,
  components_mainnav,
  mainnav___vue_template_functional__,
  mainnav___vue_styles__,
  mainnav___vue_scopeId__,
  mainnav___vue_module_identifier__
)

/* harmony default export */ var src_components_mainnav = (mainnav_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/slider.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var slider = ({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    },
    value: {
      type: Number,
      default: 0
    },
    type: String,
    name: String,
    size: String,
    isFullwidth: Boolean,
    disabled: Boolean,
    // orientation:
    vertical: Boolean
  },
  data: function data() {
    return {
      realValue: this.value
    };
  },
  beforeMount: function beforeMount() {
    this.update(this.value);
  },
  mounted: function mounted() {
    this.$el.style.setProperty('--low', this.low);
    this.$el.style.setProperty('--high', this.high);
  },

  watch: {
    realValue: function realValue(newVal, oldVal) {
      if (Number(newVal) !== Number(oldVal)) {
        this.$el.style.setProperty('--high', this.high);
        this.$emit('change', newVal);
      }
    },
    value: function value(val) {
      this.update(val);
    }
  },
  methods: {
    update: function update(val) {
      if (val > this.max) {
        this.realValue = this.max;
      } else if (val < this.min) {
        this.realValue = this.min;
      } else {
        this.realValue = val;
      }
    }
  },
  computed: {
    low: function low() {
      return '0%';
    },
    high: function high() {
      return (this.realValue - this.min) / (this.max - this.min) * 100 + '%';
    },
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          isFullwidth = this.isFullwidth;

      return _ref = {
        slider: true
      }, defineProperty_default()(_ref, 'is-' + type, type), defineProperty_default()(_ref, 'is-' + size, size), defineProperty_default()(_ref, 'is-fullwidth', isFullwidth), _ref;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9b86136","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
var slider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.realValue),expression:"realValue"}],class:_vm.classObject,attrs:{"type":"range","name":_vm.name,"min":_vm.min || 0,"max":_vm.max || 1,"step":_vm.step,"orient":_vm.vertical && 'vertical',"disabled":_vm.disabled,"number":""},domProps:{"value":(_vm.realValue)},on:{"__r":function($event){_vm.realValue=$event.target.value}}})}
var slider_staticRenderFns = []
var slider_esExports = { render: slider_render, staticRenderFns: slider_staticRenderFns }
/* harmony default export */ var components_slider = (slider_esExports);
// CONCATENATED MODULE: ./src/components/slider.vue
function slider_injectStyle (ssrContext) {
  __webpack_require__("0/X7")
}
var slider_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var slider___vue_template_functional__ = false
/* styles */
var slider___vue_styles__ = slider_injectStyle
/* scopeId */
var slider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var slider___vue_module_identifier__ = null
var slider_Component = slider_normalizeComponent(
  slider,
  components_slider,
  slider___vue_template_functional__,
  slider___vue_styles__,
  slider___vue_scopeId__,
  slider___vue_module_identifier__
)

/* harmony default export */ var src_components_slider = (slider_Component.exports);

// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__("H9QG");
var luxon_default = /*#__PURE__*/__webpack_require__.n(luxon);

// CONCATENATED MODULE: ./src/mixins/common.js


var conversions = {
  ae: 'ä|æ|ǽ',
  oe: 'ö|œ',
  ue: 'ü',
  a: 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª',
  c: 'ç|ć|ĉ|ċ|č',
  d: 'ð|ď|đ',
  e: 'è|é|ê|ë|ē|ĕ|ė|ę|ě',
  g: 'ĝ|ğ|ġ|ģ',
  h: 'ĥ|ħ',
  i: 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı',
  j: 'ĵ',
  k: 'ķ',
  l: 'ĺ|ļ|ľ|ŀ|ł',
  n: 'ñ|ń|ņ|ň|ŉ',
  o: 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º',
  r: 'ŕ|ŗ|ř',
  s: 'ś|ŝ|ş|š|ſ',
  t: 'ţ|ť|ŧ',
  u: 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ',
  y: 'ý|ÿ|ŷ',
  w: 'ŵ',
  z: 'ź|ż|ž',
  ss: 'ß',
  ij: 'ĳ',
  f: 'ƒ'
};

/* harmony default export */ var common = ({
  methods: {
    getLocale: function getLocale(locale) {
      switch (locale) {
        case 'de':
          {
            return 'de-DE';
          }
        default:
          return 'en-US';
      }
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' \u20AC';
    },
    isScheduled: function isScheduled(date) {
      var publishDate = luxon["DateTime"].fromISO(date);
      var currentDate = luxon["DateTime"].local();
      var diff = currentDate.diff(publishDate).toObject();
      return diff.milliseconds < 0;
    },
    centToEuro: function centToEuro(value, format) {
      var euro = value / 100;
      return format ? this.formatPrice(euro) : euro;
    },
    euroToCent: function euroToCent(value) {
      return value * 100;
    },
    amountFormatted: function amountFormatted(value) {
      return this.centToEuro(value, true);
    },
    getStatusTagClass: function getStatusTagClass(status) {
      var tagClass = 'is-dark';
      if (status === 'published') tagClass = 'is-success';
      return tagClass;
    },
    getDateTagClass: function getDateTagClass(status) {
      var tagClass = '';
      if (status === 'scheduled') tagClass = 'is-warning';
      if (status === 'published') tagClass = 'is-light';
      return tagClass;
    },
    getTranslation: function getTranslation(key, options) {
      return this.$i18n.t(key, options);
    },
    urlSlug: function urlSlug(str) {
      if (!str) return 'no-title';

      var formatted = str.toLowerCase();
      for (var i in conversions) {
        formatted = formatted.replace(new RegExp(conversions[i], 'g'), i);
      }
      formatted = formatted.replace(/[^\w ]+/g, '').replace(/ +/g, '-');
      return formatted;
    },
    percentage: function percentage(value, total) {
      if (value) {
        return Math.round(value / total * 100);
      }
      return 0;
    },
    relativePercentage: function relativePercentage(values, value) {
      var total = values.reduce(function (acc, val) {
        return acc + val.count;
      }, 0);
      return this.percentage(value, total);
    },
    getLocalizedUrl: function getLocalizedUrl(path) {
      if (!window) return path;

      var protocol = window.document.location.protocol;
      var hostLocale = void 0;
      var host = void 0;
      var result = window.document.location.host.match(/^([A-Za-z]{2})\./);
      if (result && result[1]) {
        hostLocale = result[1];
        host = window.document.location.host.split(result[0])[1];
      }

      if (!host && !hostLocale && this.$i18n.locale !== 'en') {
        return protocol + '//' + this.$i18n.locale + '.' + window.document.location.host + path;
      }

      if (host && hostLocale && hostLocale !== this.$i18n.locale) {
        return protocol + '//' + (this.$i18n.locale !== 'en' ? this.$i18n.locale + '.' : '') + host + path;
      }

      return path;
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/dates.js


var _timespans = [{
  value: 'thisMonth',
  localeString: 'dashboard.timespans.thisMonth',
  grammarString: 'dashboard.timespans.thisMonth_grammar'
}, {
  value: 'lastMonth',
  localeString: 'dashboard.timespans.lastMonth',
  grammarString: 'dashboard.timespans.lastMonth_grammar'
}, {
  value: 'thisYear',
  localeString: 'dashboard.timespans.thisYear',
  grammarString: 'dashboard.timespans.thisYear_grammar'
}, {
  value: 'lastYear',
  localeString: 'dashboard.timespans.lastYear',
  grammarString: 'dashboard.timespans.lastYear_grammar'
}];

/* harmony default export */ var dates = ({
  computed: {
    timespans: function timespans() {
      return _timespans;
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      var input = luxon["DateTime"].fromISO(date);
      return date && input.isValid ? input.setLocale(this.getLocale(this.$i18n.locale)).toLocaleString(luxon["DateTime"].DATETIME_SHORT) : '';
    },
    formatDateShort: function formatDateShort(date) {
      var input = luxon["DateTime"].fromISO(date);
      return date && input.isValid ? input.setLocale(this.getLocale(this.$i18n.locale)).toLocaleString(luxon["DateTime"].DATE_SHORT) : '';
    },
    dateTime: function dateTime() {
      return luxon["DateTime"];
    },
    currentDate: function currentDate() {
      return luxon["DateTime"].local();
    },
    getDateString: function getDateString(scope, date) {
      if (scope === 'day') {
        return date.toLocaleString();
      }
      if (scope === 'month') {
        return date.monthLong;
      }
    },
    startOfLastMonth: function startOfLastMonth() {
      return luxon["DateTime"].local().minus({ month: 1 }).startOf('month').toISO();
    },
    endOfLastMonth: function endOfLastMonth() {
      return luxon["DateTime"].local().minus({ month: 1 }).endOf('month').toISO();
    },
    startOfLastYear: function startOfLastYear() {
      return luxon["DateTime"].local().minus({ years: 1 }).startOf('year').toISO();
    },
    endOfLastYear: function endOfLastYear() {
      return luxon["DateTime"].local().minus({ years: 1 }).endOf('year').toISO();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__("abWm");
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// CONCATENATED MODULE: ./src/api.js







/* harmony default export */ var src_api = ({
  install: function install(Vue, options) {
    var _this = this;

    /**
     * initialize HTTPClient
     */
    var HTTP = axios_default.a.create({
      baseURL: options.baseURL,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 500;
      }
    });

    /**
     * resign new requests with current auth token
     */
    HTTP.interceptors.request.use(function (config) {
      return config;
    });

    /**
     * error handling
     */
    var onError = function onError(e) {
      console.error('API HTTP Error', e);
    };

    /**
     * generic request
     */
    var request = function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(method, url, data, params) {
        var response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return HTTP.request({ method: method, url: url, data: data, params: params });

              case 3:
                response = _context.sent;

                if (!(response.status < 300)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', response.data);

              case 6:
                if (!(response.status === 401)) {
                  _context.next = 9;
                  break;
                }

                message_default()({
                  message: response.data.message || 'Authentication Error',
                  type: 'error',
                  duration: 3500,
                  showClose: true
                });
                return _context.abrupt('return', options.store.dispatch('logout'));

              case 9:
                if (response.status === 403) {
                  message_default()({
                    message: response.data.message || 'Forbidden',
                    type: 'error',
                    duration: 3500,
                    showClose: true
                  });
                  // return options.store.dispatch('logout')
                }
                if (response.status >= 400) {
                  message_default()({
                    message: response.data.message || 'An unknown error occured',
                    type: 'error',
                    duration: 3500,
                    showClose: true
                  });
                }
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                onError(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }));

      return function request(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();

    var refreshToken = function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var token, decoded, result;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                token = options.store.state.token;

                if (!token) {
                  _context2.next = 8;
                  break;
                }

                decoded = jsonwebtoken_default.a.decode(token);

                if (!(Date.now() - decoded.exp * 1000 < 0)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return request('post', 'refresh', { token: token });

              case 6:
                result = _context2.sent;

                options.store.commit('setToken', result.token);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function refreshToken() {
        return _ref2.apply(this, arguments);
      };
    }();

    setInterval(refreshToken, 30 * 1000);

    var updateStatus = function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return request('get', 'status');

              case 2:
                response = _context3.sent;

                if (response && response.status) {
                  options.store.dispatch('updateStatus', response);
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function updateStatus() {
        return _ref3.apply(this, arguments);
      };
    }();

    /**
     * expose api[Post|Get|etc.]
     */
    Vue.prototype.apiPost = function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(url, data) {
        var response;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return request('post', url, data);

              case 2:
                response = _context4.sent;

                updateStatus();
                return _context4.abrupt('return', response);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }();

    Vue.prototype.apiPut = function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(url, data) {
        var response;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return request('put', url, data);

              case 2:
                response = _context5.sent;

                updateStatus();
                return _context5.abrupt('return', response);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this);
      }));

      return function (_x7, _x8) {
        return _ref5.apply(this, arguments);
      };
    }();

    Vue.prototype.apiGet = function () {
      var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(url, params) {
        var doUpdateStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var response;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return request('get', url, null, params);

              case 2:
                response = _context6.sent;

                if (doUpdateStatus) updateStatus();
                return _context6.abrupt('return', response);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this);
      }));

      return function (_x9, _x10) {
        return _ref6.apply(this, arguments);
      };
    }();

    Vue.prototype.apiDelete = function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(url) {
        var response;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return request('delete', url);

              case 2:
                response = _context7.sent;

                updateStatus();
                return _context7.abrupt('return', response);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this);
      }));

      return function (_x12) {
        return _ref7.apply(this, arguments);
      };
    }();
  }
});
// CONCATENATED MODULE: ./src/checkout.js




/* harmony default export */ var checkout = ({
  install: function install(Vue, options) {
    var _this = this;

    /**
    * initialize HTTPClient
    */
    var HTTP = axios_default.a.create({
      baseURL: '/checkout/api/',
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 500;
      }
    });

    /**
     * resign new requests with current auth token
     */
    HTTP.interceptors.request.use(function (config) {
      return config;
    });

    /**
     * error handling
     */
    var onError = function onError(e) {
      console.error('API HTTP Error', e);
    };

    /**
     * generic request
     */
    var request = function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(method, url, data, params, cookie) {
        var headers, response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                console.log('[API]', { method: method, url: url, data: data, params: params, cookie: cookie });
                headers = null;

                if (cookie) headers = { Cookie: cookie };
                _context.next = 6;
                return HTTP.request({ method: method, url: url, data: data, params: params, headers: headers });

              case 6:
                response = _context.sent;

                if (!(response.status < 300)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return', response.data);

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                onError(_context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }));

      return function request(_x, _x2, _x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }();

    Vue.prototype.checkoutGet = function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(url, params) {
        var response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request('get', url, null, params);

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', response);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x6, _x7) {
        return _ref2.apply(this, arguments);
      };
    }();
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/notification.js
var notification = __webpack_require__("yg6k");
var notification_default = /*#__PURE__*/__webpack_require__.n(notification);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/message-box.js
var message_box = __webpack_require__("+TD8");
var message_box_default = /*#__PURE__*/__webpack_require__.n(message_box);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/config/i18n.js




vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

function getCookie(cookieName) {
  var name = cookieName + '=';
  var cDecoded = decodeURIComponent(document.cookie);
  var cArr = cDecoded.split('; ');
  var res = void 0;
  cArr.forEach(function (val) {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}

var languages = ['en', 'de'];
var i18n_locale = "en";

if (window) {
  // set by subdomain
  var i18n_result = window.document.location.host.match(/^([A-Za-z]{2})\./);
  if (i18n_result && i18n_result.length > 1 && languages.includes(i18n_result[1])) {
    i18n_locale = i18n_result[1];
  }

  // set by cookie
  if (document) {
    var cookieLang = getCookie('i18n');
    if (languages.includes(cookieLang)) {
      i18n_locale = cookieLang;
    }
  }
}

var messages = {};
var i18n__iteratorNormalCompletion = true;
var i18n__didIteratorError = false;
var i18n__iteratorError = undefined;

try {
  for (var i18n__iterator = get_iterator_default()(languages), i18n__step; !(i18n__iteratorNormalCompletion = (i18n__step = i18n__iterator.next()).done); i18n__iteratorNormalCompletion = true) {
    var lang = i18n__step.value;

    messages[lang] = __webpack_require__("1etf")("./" + lang + '.json');
  }
} catch (err) {
  i18n__didIteratorError = true;
  i18n__iteratorError = err;
} finally {
  try {
    if (!i18n__iteratorNormalCompletion && i18n__iterator.return) {
      i18n__iterator.return();
    }
  } finally {
    if (i18n__didIteratorError) {
      throw i18n__iteratorError;
    }
  }
}

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: i18n_locale,
  messages: messages
});

/* harmony default export */ var config_i18n = (i18n);
// EXTERNAL MODULE: ./node_modules/dottie/dottie.js
var dottie = __webpack_require__("VUYF");
var dottie_default = /*#__PURE__*/__webpack_require__.n(dottie);

// CONCATENATED MODULE: ./src/dialogues.js









/* harmony default export */ var dialogues = ({
  install: function install(Vue) {
    Vue.prototype.$msgbox = message_box_default.a;
    Vue.prototype.$alert = message_box_default.a.alert;
    Vue.prototype.$confirm = message_box_default.a.confirm;
    Vue.prototype.$prompt = message_box_default.a.prompt;

    // Vue.prototype.$loading = Loading.service
    Vue.prototype.$notify = notification_default.a;
    Vue.prototype.$message = message_default.a;

    Vue.prototype.$success = function (message) {
      message_default()({
        message: message || 'All fine...',
        type: 'success',
        duration: 1500
      });
    };

    Vue.prototype.$notifySuccess = function (message) {
      notification_default()({
        title: 'Success',
        message: message || 'Data saved successfully',
        type: 'success'
      });
    };

    Vue.prototype.$notifyError = function (error) {
      var title = void 0,
          message = void 0,
          locale = void 0;
      if (!error) {
        title = 'info.errors.standard.title';
        message = 'info.errors.standard.message';
        locale = 'en';
      } else {
        title = error.title;
        message = error.message;
        locale = error.locale || 'en';
      }

      var h = new Vue().$createElement;
      var m = h('div', { class: 'content' }, [h('p', {}, dottie_default.a.get(config_i18n.messages[locale], message))]);

      notification_default()({
        title: dottie_default.a.get(config_i18n.messages[locale], title),
        message: m,
        type: 'error'
      });
    };

    Vue.prototype.$notifySuccessDeleted = function (_ref) {
      var titleKey = _ref.titleKey,
          messageKey = _ref.messageKey,
          locale = _ref.locale,
          duration = _ref.duration;

      if (titleKey && messageKey && locale) {
        return notification_default()({
          title: dottie_default.a.get(config_i18n.messages[locale], titleKey),
          message: dottie_default.a.get(config_i18n.messages[locale], messageKey),
          type: 'success',
          duration: duration || 4500
        });
      }
      notification_default()({
        title: 'Success',
        message: 'Data deleted successfully',
        type: 'success'
      });
    };

    Vue.prototype.$notifyActiveRewards = function (activeRewards) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

      var title = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activeRewardNotification.title');
      var heading = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activeRewardNotification.heading');
      var text = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activeRewardNotification.message');
      var h = new Vue().$createElement;
      var rewards = activeRewards.map(function (r) {
        return h('li', [h('a', { attrs: { href: '/myprofile/rewards/edit/' + r._id } }, '- ' + r.name)]);
      });
      var message = h('div', [h('h1', { class: { 'warn-h1': true }, style: { 'text-align': 'left' } }, heading), h('p', { style: { 'text-align': 'left' } }, text + ':'), h('ul', { class: { 'warn-ul': true } }, rewards)]);
      notification_default()({
        title: title,
        message: message,
        type: 'error'
      });
    };

    Vue.prototype.$notifyActivePledges = function (activePledges) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

      var title = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activePledgeNotification.title');
      var heading = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activePledgeNotification.heading');
      var text = dottie_default.a.get(config_i18n.messages[locale], 'account.delete.activePledgeNotification.message');

      var h = new Vue().$createElement;
      var pledges = activePledges.map(function (p) {
        return h('li', [h('a', { attrs: { href: '/myprofile/purchases/edit/reward/' + p._id } }, '- ' + p.rewardName)]);
      });
      var message = h('div', [h('h1', { class: { 'warn-h1': true }, style: { 'text-align': 'left' } }, heading), h('p', { style: { 'text-align': 'left' } }, text + ':'), h('ul', { class: { 'warn-ul': true } }, pledges)]);
      notification_default()({
        title: title,
        message: message,
        type: 'error'
      });
    };

    Vue.prototype.$confirmAccountDeletion = function (methodOptions) {
      var user = methodOptions.user;
      var translation = config_i18n.messages[methodOptions.locale].account.delete.confirmation;
      var h = new Vue().$createElement;

      var title = translation.goodbye;
      var content = void 0;
      if (user.artist) {
        content = h('p', translation.artist.when);
      } else {
        content = h('p', translation.fan.when);
      }

      var message = h('div', [h('p', translation.greeting + ' ' + user.nickname + ','), h('p', translation.honey), content]);

      return message_box_default.a.confirm(message, title, {
        confirmButtonText: 'Delete Account',
        cancelButtonText: 'Cancel',
        type: 'error'
      }).catch(function (e) {});
    };

    Vue.prototype.$confirmDelete = function (methodOptions) {
      var defaults = {
        message: 'This will permanently delete this item. Proceed anyway?',
        title: 'Danger'
      };
      var options = assign_default()({}, defaults, methodOptions);
      return message_box_default.a.confirm(options.message, options.title, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'error',
        dangerouslyUseHTMLString: options.dangerouslyUseHTMLString
      }).catch(function (e) {});
    };

    Vue.prototype.$confirmSave = function (methodOptions) {
      var defaults = {
        message: 'Please confirm to save of your data',
        title: 'Save your data'
      };
      var options = assign_default()({}, defaults, methodOptions);
      return message_box_default.a.confirm(options.message, options.title, {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).catch(function (e) {});
    };

    Vue.prototype.$confirmUnsaved = function () {
      return message_box_default.a.confirm(config_i18n.messages[config_i18n.locale].confirm.unsaved.message, config_i18n.messages[config_i18n.locale].confirm.unsaved.title, {
        confirmButtonText: config_i18n.messages[config_i18n.locale].confirm.unsaved.ok,
        cancelButtonText: config_i18n.messages[config_i18n.locale].confirm.unsaved.cancel,
        type: 'warning'
      }).catch(function (e) {});
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/top-arrow.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var top_arrow = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ecce26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/top-arrow.vue
var top_arrow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":40,"height":40,"viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:cc":"http://creativecommons.org/ns#","xmlns:dc":"http://purl.org/dc/elements/1.1/","xmlns:rdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"}},[_c('metadata',[_c('rdf:RDF',[_c('cc:Work',{attrs:{"rdf:about":""}},[_c('dc:format',[_vm._v("image/svg+xml")]),_vm._v(" "),_c('dc:type',{attrs:{"rdf:resource":"http://purl.org/dc/dcmitype/StillImage"}}),_vm._v(" "),_c('dc:title')],1)],1)],1),_vm._v(" "),_c('g',{attrs:{"stroke":"#d40000","stroke-width":"2"}},[_c('path',{staticClass:"top-arrow-path",attrs:{"d":"m9.9956 1.7319c0.75604 2e-5 1.4842 0.09966 2.1846 0.2989 0.70036 0.19929 1.3582 0.47768 1.9736 0.83516 0.61537 0.35753 1.1751 0.78683 1.6791 1.2879 0.50402 0.50112 0.93625 1.0579 1.2967 1.6703 0.36043 0.61247 0.64028 1.2703 0.83956 1.9736 0.19925 0.70331 0.29889 1.433 0.2989 2.189-1.5e-5 0.75606-0.09965 1.4843-0.2989 2.1846-0.19928 0.70038-0.47914 1.3553-0.83956 1.9648-0.36045 0.60953-0.79269 1.1678-1.2967 1.6747-0.50404 0.50696-1.0637 0.94066-1.6791 1.3011-0.6154 0.36044-1.2733 0.64176-1.9736 0.84396-0.70037 0.2022-1.4286 0.3033-2.1846 0.3033-0.75605 4e-6 -1.4843-0.09963-2.1846-0.2989-0.70037-0.19926-1.3568-0.47912-1.9692-0.83956-0.61245-0.36044-1.1692-0.79267-1.6703-1.2967-0.5011-0.50402-0.93187-1.0637-1.2923-1.6791-0.36044-0.61538-0.64029-1.2733-0.83956-1.9736-0.19926-0.70036-0.2989-1.4286-0.2989-2.1846 1e-6 -0.75603 0.09964-1.4857 0.2989-2.189 0.19927-0.70328 0.47766-1.3612 0.83516-1.9736 0.35751-0.61244 0.78681-1.1692 1.2879-1.6703 0.5011-0.50108 1.0593-0.93038 1.6747-1.2879 0.61538-0.35749 1.2733-0.63588 1.9736-0.83516 0.70036-0.19925 1.4286-0.29888 2.1846-0.2989zm0.035172 2.7692h-0.035172l-4.211 4.0264v2.9187l3.1385-3.0681v6.6725h2.1802v-6.6725l3.1385 3.0681v-2.9187zm-0.043964-4.5011c-0.90843 2.1e-5 -1.7846 0.12017-2.6286 0.36044-0.84396 0.24032-1.6366 0.58024-2.378 1.0198-0.74139 0.43958-1.4169 0.96412-2.0264 1.5736-0.60952 0.60954-1.1341 1.285-1.5736 2.0264-0.43956 0.74141-0.77948 1.5355-1.0198 2.3824-0.24029 0.8469-0.36044 1.7246-0.36044 2.633 3e-6 0.90844 0.12016 1.7861 0.36044 2.633 0.2403 0.8469 0.57729 1.641 1.011 2.3824 0.4337 0.7414 0.95531 1.4183 1.5648 2.0308 0.60952 0.61246 1.285 1.1385 2.0264 1.578 0.74139 0.43956 1.5355 0.77949 2.3824 1.0198 0.84688 0.2403 1.7275 0.36044 2.6418 0.36044 0.90842 2e-6 1.7861-0.12014 2.633-0.36044 0.84688-0.24029 1.641-0.58022 2.3824-1.0198 0.74138-0.43956 1.4183-0.96556 2.0308-1.578 0.61244-0.61245 1.1384-1.2894 1.578-2.0308 0.43954-0.74138 0.78094-1.5355 1.0242-2.3824 0.24321-0.84688 0.36482-1.7245 0.36484-2.633-1.6e-5 -0.90841-0.12016-1.7861-0.36044-2.633-0.24031-0.84687-0.57877-1.641-1.0154-2.3824-0.43664-0.74137-0.96119-1.4168-1.5736-2.0264-0.61247-0.6095-1.2894-1.134-2.0308-1.5736-0.7414-0.43954-1.537-0.77947-2.3868-1.0198-0.84982-0.24027-1.7319-0.36042-2.6462-0.36044z","fill":"#eeeeee","stroke":"none"}})])],1)}
var top_arrow_staticRenderFns = []
var top_arrow_esExports = { render: top_arrow_render, staticRenderFns: top_arrow_staticRenderFns }
/* harmony default export */ var icons_top_arrow = (top_arrow_esExports);
// CONCATENATED MODULE: ./src/components/icons/top-arrow.vue
var top_arrow_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var top_arrow___vue_template_functional__ = false
/* styles */
var top_arrow___vue_styles__ = null
/* scopeId */
var top_arrow___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var top_arrow___vue_module_identifier__ = null
var top_arrow_Component = top_arrow_normalizeComponent(
  top_arrow,
  icons_top_arrow,
  top_arrow___vue_template_functional__,
  top_arrow___vue_styles__,
  top_arrow___vue_scopeId__,
  top_arrow___vue_module_identifier__
)

/* harmony default export */ var components_icons_top_arrow = (top_arrow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/scroll-to-top.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var scroll_to_top = ({
  components: { topArrow: components_icons_top_arrow },
  data: function data() {
    return {
      timeoutId: null,
      visible: false,
      mainContent: null
    };
  },
  methods: {
    scrollTop: function scrollTop() {
      if (this.mainContent) {
        this.mainContent.scrollTop = 0;
      }
    },
    onScroll: function onScroll(event) {
      var _this = this;

      if (!this.timeoutId) {
        this.timeoutId = setTimeout(function () {
          _this.visible = event.target.scrollTop > 100;
          _this.timeoutId = null;
        }, 150);
      }
    },
    attachListener: function attachListener() {
      this.mainContent = document.querySelector('#mainContent');
      if (this.mainContent) {
        this.mainContent.removeEventListener('scroll', this.onScroll, { passive: true });
        this.mainContent.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }
  },
  mounted: function mounted() {
    this.$root.$on('contentmounted', this.attachListener);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('contentmounted', this.attachListener);
    if (this.mainContent) {
      this.mainContent.removeEventListener('scroll', this.onScroll, { passive: true });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23039c67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll-to-top.vue
var scroll_to_top_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:{ 'one-column': _vm.$mq === 'sm' },attrs:{"id":"scrollTop"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTop()}}},[_c('topArrow')],1):_vm._e()}
var scroll_to_top_staticRenderFns = []
var scroll_to_top_esExports = { render: scroll_to_top_render, staticRenderFns: scroll_to_top_staticRenderFns }
/* harmony default export */ var components_scroll_to_top = (scroll_to_top_esExports);
// CONCATENATED MODULE: ./src/components/scroll-to-top.vue
function scroll_to_top_injectStyle (ssrContext) {
  __webpack_require__("ZO/S")
}
var scroll_to_top_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var scroll_to_top___vue_template_functional__ = false
/* styles */
var scroll_to_top___vue_styles__ = scroll_to_top_injectStyle
/* scopeId */
var scroll_to_top___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroll_to_top___vue_module_identifier__ = null
var scroll_to_top_Component = scroll_to_top_normalizeComponent(
  scroll_to_top,
  components_scroll_to_top,
  scroll_to_top___vue_template_functional__,
  scroll_to_top___vue_styles__,
  scroll_to_top___vue_scopeId__,
  scroll_to_top___vue_module_identifier__
)

/* harmony default export */ var src_components_scroll_to_top = (scroll_to_top_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'app',
  components: {
    scrollToTop: src_components_scroll_to_top
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ffc344","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('scroll-to-top')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("y1Aq")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/can-ndjson-stream/can-ndjson-stream.js
var can_ndjson_stream = __webpack_require__("ocMT");
var can_ndjson_stream_default = /*#__PURE__*/__webpack_require__.n(can_ndjson_stream);

// CONCATENATED MODULE: ./src/lib/streamApi.js


var streamApi__this = this;



/* harmony default export */ var streamApi = ({
  methods: {
    streamJson: function streamJson() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var onDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

      fetch('' + "/api/private/" + path, extends_default()({}, streamApi__this.config, {
        method: 'GET'
      })).then(function (response) {
        return can_ndjson_stream_default()(response.body);
      }).then(function (docStream) {
        var _read = void 0;
        var reader = docStream.getReader();
        reader.read().then(_read = function read(_ref) {
          var value = _ref.value,
              done = _ref.done;

          if (done) return onDone();
          handle(value);
          reader.read().then(_read);
        });
      });

      return true;
    }
  }

});
// CONCATENATED MODULE: ./src/store/index.js









vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    user: {},
    status: {},
    token: '',
    isAuthenticated: false,
    isConnected: false,
    userListViewParams: {
      q: '',
      sort: 'username',
      direction: 1,
      page: 1,
      limit: 10,
      currentRow: -1,
      lastSeenRecordId: null
    },
    postsLoaded: false,
    newslettersLoaded: false,
    purchasables: []
  },

  mutations: {
    setUser: function setUser(state, user) {
      if (user) {
        state.isAuthenticated = true;
        state.user = user;
      }
    },
    setStatus: function setStatus(state, status) {
      state.status = status;
    },
    setToken: function setToken(state, token) {
      state.token = token;
    },
    setUserListViewParams: function setUserListViewParams(state, params) {
      state.userListViewParams = params;
    },
    setAvatar: function setAvatar(state, path) {
      state.user.profile.imgs.avatar = path;
    },
    addFollowerCount: function addFollowerCount(state, value) {
      if (state.user) {
        state.user.followers += value;
      }
    },
    clearPosts: function clearPosts(state) {
      state.user = assign_default()({}, state.user, { stickyPosts: [], posts: [] });
      state.postsLoaded = false;
    },
    addPosts: function addPosts(state, posts) {
      if (state.user) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            if (p.sticky) {
              state.user.stickyPosts.push(p);
              continue;
            }
            state.user.posts.push(p);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    setPostsLoaded: function setPostsLoaded(state, loaded) {
      state.postsLoaded = loaded;
    },
    clearNewsletters: function clearNewsletters(state) {
      state.user = assign_default()({}, state.user, { newsletters: [] });
      state.newslettersLoaded = false;
    },
    addNewsletters: function addNewsletters(state, newsletters) {
      if (state.user) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(newsletters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var n = _step2.value;

            state.user.newsletters.push(n);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    setNewslettersLoaded: function setNewslettersLoaded(state, loaded) {
      state.newslettersLoaded = loaded;
    },
    setPurchasables: function setPurchasables(state, data) {
      state.purchasables = data;
    },
    logout: function logout(state) {
      state.isAuthenticated = false;
      state.token = '';
      state.user = {
        profile: {}
      };
    }
  },
  getters: {
    isAuthenticated: function isAuthenticated(state) {
      return state.isAuthenticated;
    },
    isArtist: function isArtist(state) {
      return state.user ? state.user.artist : false;
    },
    currentUser: function currentUser(state) {
      return state.user;
    },
    purchasables: function purchasables(state) {
      return state.purchasables;
    }
  },
  actions: {
    logout: function logout(context) {
      context.commit('logout');
    },
    login: function login(context, data) {
      context.commit('setUser', data.user);
    },
    reLogin: function reLogin(context, data) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.methods.apiGet('user');

              case 2:
                response = _context.sent;

                if (response && response.user) {
                  context.commit('setUser', response.user);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateStatus: function updateStatus(context, data) {
      context.commit('setStatus', data.status);
    },
    updateAvatar: function updateAvatar(context, path) {
      context.commit('setAvatar', path);
    },
    handleFollowerEvent: function handleFollowerEvent(context, event) {
      var val = 0;
      if (event.data === '"subscribe"') {
        val = 1;
      } else if (event.data === '"unsubscribe"') {
        val = -1;
      }
      context.commit('addFollowerCount', val);
    },
    setInterfaceLanguage: function setInterfaceLanguage(context, code) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!context.state.isAuthenticated) {
                  _context2.next = 9;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return api.methods.apiPost('/preferences/interface-language', {
                  interfaceLanguage: code
                });

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

                console.log('Error setting interface language: ', _context2.t0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 6]]);
      }))();
    },
    loadProfile: function loadProfile(context) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!context.state.user.rewards) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.next = 4;
                return api.methods.apiGet('stream/myprofile');

              case 4:
                response = _context3.sent;

                if (response && response.user) {
                  context.commit('setUser', response.user);
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadPosts: function loadPosts(context) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var updateStatus, list, counter;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                updateStatus = function () {
                  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                    var response;
                    return regenerator_default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return api.methods.apiGet('status');

                          case 2:
                            response = _context4.sent;

                            _this4.dispatch('updateStatus', response);

                          case 4:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4);
                  }));

                  return function updateStatus() {
                    return _ref.apply(this, arguments);
                  };
                }();

                list = [];
                counter = 0;

                context.commit('clearPosts');
                streamApi.methods.streamJson('stream/posts', function (post) {
                  counter += 1;
                  if (counter === 11) {
                    context.commit('addPosts', list);
                    context.commit('setPostsLoaded', true);
                    list = [];
                  }
                  list.push(post);
                  if (counter % 61 === 0) {
                    context.commit('addPosts', list);
                    list = [];
                  }
                }, function () {
                  if (list.length > 0) {
                    context.commit('addPosts', list);
                  }

                  updateStatus();
                });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    loadNewsletters: function loadNewsletters(context) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var updateStatus, list, counter;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                updateStatus = function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                    var response;
                    return regenerator_default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return api.methods.apiGet('status');

                          case 2:
                            response = _context6.sent;

                            _this5.dispatch('updateStatus', response);

                          case 4:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this5);
                  }));

                  return function updateStatus() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                list = [];
                counter = 0;

                context.commit('clearNewsletters');
                streamApi.methods.streamJson('stream/newsletters', function (newsletter) {
                  counter += 1;
                  if (counter === 11) {
                    context.commit('addNewsletters', list);
                    context.commit('setNewslettersLoaded', true);
                    list = [];
                  }
                  list.push(newsletter);
                  if (counter % 61 === 0) {
                    context.commit('addNewsletters', list);
                    list = [];
                  }
                }, function () {
                  if (list.length > 0) {
                    context.commit('addNewsletters', list);
                  }

                  updateStatus();
                });

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    setPurchasables: function setPurchasables(context, data) {
      context.commit('setPurchasables', data);
    }
  }
});
// CONCATENATED MODULE: ./src/router/index.js




/**
 * lazy loading pages
 * @see https://router.vuejs.org/en/advanced/lazy-loading.html
 */
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "c5Mg"));
};
var login = function login() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "Luci"));
};
var signup = function signup() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "sICF"));
};
var app = function app() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "5VpT"));
};

var helpIndex = function helpIndex() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "IPaL"));
};

var settingsIndex = function settingsIndex() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "NdYc"));
};
var settingsAccountEdit = function settingsAccountEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "L7HK"));
};
var settingsNotificationEdit = function settingsNotificationEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "cXm0"));
};
var settingsPayoutEdit = function settingsPayoutEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "bR8p"));
};

var dashboardIndex = function dashboardIndex() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "GTy2"));
};

var profileIndex = function profileIndex() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "N/V5"));
};
var profileEdit = function profileEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "NLI0"));
};

var productsIndex = function productsIndex() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "HByW"));
};
var productsList = function productsList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "vA2+"));
};
var productsEdit = function productsEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "IOha"));
};

var rewardsIndex = function rewardsIndex() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "A16L"));
};
var rewardsList = function rewardsList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "N80B"));
};
var rewardsEdit = function rewardsEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "JFTs"));
};

var postsIndex = function postsIndex() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "83wu"));
};
var postsList = function postsList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "Z13E"));
};
var postsEdit = function postsEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "DNYe"));
};

var newslettersIndex = function newslettersIndex() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "bhBL"));
};
var newslettersList = function newslettersList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "zR0i"));
};
var newslettersEdit = function newslettersEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "eKsJ"));
};

var tagsIndex = function tagsIndex() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "Gk16"));
};
var tagsList = function tagsList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "MgKg"));
};

var pollsIndex = function pollsIndex() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "JWnW"));
};
var pollsList = function pollsList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "bMO3"));
};

var purchasesIndex = function purchasesIndex() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "/S3G"));
};
var purchasesList = function purchasesList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "kZyU"));
};
var purchasesEdit = function purchasesEdit() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "d9Tc"));
};

var ordersIndex = function ordersIndex() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "OXuE"));
};
var ordersList = function ordersList() {
  return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "8wr0"));
};

vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '*',
    component: NotFound,
    meta: { isPublic: true }
  }, {
    path: '/',
    component: login,
    meta: { isPublic: true }
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: { isPublic: true }
  }, {
    path: '/signup',
    name: 'signup',
    component: signup,
    meta: { isPublic: true }
  }, {
    path: '/myprofile',
    component: app,
    children: [{
      path: '',
      redirect: 'dashboard'
    }, {
      path: 'settings',
      component: settingsIndex,
      children: [{
        path: '',
        name: 'settingsIndex',
        redirect: 'account'
      }, {
        path: 'account',
        name: 'accountEdit',
        component: settingsAccountEdit
      }, {
        path: 'notification',
        name: 'notificationEdit',
        component: settingsNotificationEdit
      }, {
        path: 'payout',
        name: 'payoutEdit',
        component: settingsPayoutEdit
      }]
    }, {
      path: 'help',
      name: 'helpIndex',
      component: helpIndex
    }, {
      path: 'dashboard',
      name: 'dashboardIndex',
      component: dashboardIndex
    }, {
      path: 'profile',
      component: profileIndex,
      children: [{
        path: '',
        name: 'profileEdit',
        component: profileEdit
      }]
    }, {
      path: 'products',
      component: productsIndex,
      children: [{
        path: '',
        name: 'productsList',
        redirect: {
          name: 'productsListStatus',
          params: { status: 'published' }
        }
      }, {
        path: ':status',
        name: 'productsListStatus',
        component: productsList
      }, {
        path: 'edit/:id',
        name: 'productsEdit',
        component: productsEdit
      }, {
        path: 'add',
        name: 'productsAdd',
        component: productsEdit
      }]
    }, {
      path: 'rewards',
      component: rewardsIndex,
      children: [{
        path: '',
        name: 'rewardsList',
        redirect: {
          name: 'rewardsListStatus',
          params: { status: 'published' }
        }
      }, {
        path: ':status',
        name: 'rewardsListStatus',
        component: rewardsList
      }, {
        path: 'edit/:id',
        name: 'rewardsEdit',
        component: rewardsEdit
      }, {
        path: 'add',
        name: 'rewardsAdd',
        component: rewardsEdit
      }]
    }, {
      path: 'posts',
      component: postsIndex,
      children: [{
        path: '',
        name: 'postsList',
        component: postsList
      }, {
        path: ':status',
        name: 'postsListStatus',
        component: postsList
      }, {
        path: 'edit/:id',
        name: 'postsEdit',
        component: postsEdit
      }, {
        path: 'add',
        name: 'postsAdd',
        component: postsEdit
      }, {
        path: 'tags',
        component: tagsIndex,
        children: [{
          path: 'list',
          name: 'tagsList',
          component: tagsList
        }]
      }]
    }, {
      path: 'newsletters',
      component: newslettersIndex,
      children: [{
        path: '',
        name: 'newslettersList',
        component: newslettersList
      }, {
        path: ':status',
        name: 'newslettersListStatus',
        component: newslettersList
      }, {
        path: 'edit/:id',
        name: 'newslettersEdit',
        component: newslettersEdit
      }, {
        path: 'add',
        name: 'newslettersAdd',
        component: newslettersEdit
      }]
    }, {
      path: 'polls',
      component: pollsIndex,
      children: [{
        path: '',
        name: 'pollsList',
        component: pollsList
      }]
    }, {
      path: 'purchases',
      component: purchasesIndex,
      children: [{
        path: '',
        name: 'purchasesList',
        component: purchasesList
      }, {
        path: 'edit/:purchaseType/:id',
        name: 'purchasesEdit',
        component: purchasesEdit
      }]
    }, {
      path: 'orders',
      component: ordersIndex,
      children: [{
        path: '',
        name: 'ordersList',
        component: ordersList
      }]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.name === 'dashboardIndex' && store.getters.isAuthenticated && !store.getters.isArtist) {
    return next({ name: 'profileEdit' });
  }

  if (to.matched.some(function (record) {
    return record.meta.isPublic || store.getters.isAuthenticated;
  })) {
    return next();
  }
  next({ name: 'login', query: { redirect: to.fullPath } });
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./src/bus.js
var bus = __webpack_require__("14gb");

// CONCATENATED MODULE: ./src/stats.js





var stats__this = this;




if (!window.EventSource) {
  __webpack_require__("zFrg");
}

var evtFactory = function evtFactory(onError, onMessage) {
  var es = new EventSource('/api/private/stats/stream', {
    withCredentials: true
  });
  es.onerror = onError;
  es.onmessage = onMessage;

  stats_busSubscribe();
  return es;
};

var stats_reconnect = function reconnect() {
  if (evtSource) evtSource.close();

  if (store.getters.isAuthenticated) {
    evtSource = evtFactory(stats_onError, stats_onMessage);
    stats_busSubscribe();
  }
};

var stats_onError = function onError(err) {
  console.error('Error in stats', err);
  stats_busLeave();
  setTimeout(stats_reconnect, 10000);
};

var stats_onMessage = function onMessage(msg) {
  bus["a" /* default */].emit('stream/stats/' + msg.lastEventId, msg);
};

var stats_busSubscribe = function busSubscribe() {
  bus["a" /* default */].subscribe(stats__this, 'stream/stats/followers', function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(event) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.dispatch('handleFollowerEvent', event);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, stats__this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

var stats_busLeave = function busLeave() {
  bus["a" /* default */].leave(stats__this);
};

var evtSource = evtFactory(stats_onError, stats_onMessage);
// EXTERNAL MODULE: ./src/assets/sass/element-variables.scss
var element_variables = __webpack_require__("F+RQ");
var element_variables_default = /*#__PURE__*/__webpack_require__.n(element_variables);

// EXTERNAL MODULE: ./src/assets/sass/main.scss
var main = __webpack_require__("JD12");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/apollo-client/index.js + 13 modules
var apollo_client = __webpack_require__("u1/p");

// EXTERNAL MODULE: ./node_modules/apollo-link-http/lib/index.js + 2 modules
var lib = __webpack_require__("rp1p");

// EXTERNAL MODULE: ./node_modules/apollo-cache-inmemory/lib/index.js + 13 modules
var apollo_cache_inmemory_lib = __webpack_require__("+dIz");

// EXTERNAL MODULE: ./node_modules/vue-apollo/dist/vue-apollo.esm.js
var vue_apollo_esm = __webpack_require__("69U5");

// CONCATENATED MODULE: ./src/main.js

























// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



































// import initNotifications from '@/notifications'









var GRAPHCMS_API = 'https://getnext.to/content/';
var httpLink = new lib["a" /* HttpLink */]({
  uri: GRAPHCMS_API
});

var apolloClient = new apollo_client["a" /* ApolloClient */]({
  link: httpLink,
  cache: new apollo_cache_inmemory_lib["a" /* InMemoryCache */](),
  connectToDevTools: true
});

vue_esm["default"].use(vue_apollo_esm["a" /* default */]);

var apolloProvider = new vue_apollo_esm["a" /* default */]({
  defaultClient: apolloClient
});

Object(vuex_router_sync["sync"])(store, src_router); // done. Returns an unsync callback fn

vue_esm["default"].use(dist_default.a, { prevent: ['input', 'textarea'] });
vue_esm["default"].use(textfield["a" /* default */]);

// configure language for el-ui
locale_default.a.use(en_default.a);

vue_esm["default"].use(alert_default.a);
vue_esm["default"].use(pagination_default.a);
vue_esm["default"].use(select_default.a);
vue_esm["default"].use(option_default.a);
vue_esm["default"].use(date_picker_default.a);
vue_esm["default"].use(time_select_default.a);
vue_esm["default"].use(time_picker_default.a);
vue_esm["default"].use(checkbox_default.a);
vue_esm["default"].use(checkbox_button_default.a);
vue_esm["default"].use(checkbox_group_default.a);
vue_esm["default"].use(input_number_default.a);

vue_esm["default"].use(button_default.a);
vue_esm["default"].use(dropdown_default.a);
vue_esm["default"].use(dropdown_menu_default.a);
vue_esm["default"].use(dropdown_item_default.a);
vue_esm["default"].use(dialog_default.a);
vue_esm["default"].use(switch_default.a);
vue_esm["default"].use(upload_default.a);
vue_esm["default"].use(progress_default.a);
vue_esm["default"].use(form_default.a);
vue_esm["default"].use(form_item_default.a);
vue_esm["default"].use(table_default.a);
vue_esm["default"].use(table_column_default.a);
vue_esm["default"].use(tabs_default.a);
vue_esm["default"].use(tab_pane_default.a);
vue_esm["default"].use(vue_clipboard_default.a);
vue_esm["default"].use(vue_scrollto_default.a);

vue_esm["default"].use(vue_flag_icon["a" /* default */]);

vue_esm["default"].use(vue_mq_es["a" /* default */], {
  breakpoints: { // default breakpoints - customize this
    sm: 768,
    md: 1250,
    lg: Infinity
  },
  defaultBreakpoint: 'sm' // customize this for SSR
});

vue_esm["default"].component('searchbar', src_components_searchbar);
vue_esm["default"].component('input-error', src_components_input_error);
vue_esm["default"].component('input-text', src_components_input_text);
vue_esm["default"].component('sortable', src_components_sortable);
vue_esm["default"].component('mainfooter', components_mainfooter);
vue_esm["default"].component('mainnav', src_components_mainnav);
vue_esm["default"].component('slider', src_components_slider);
vue_esm["default"].component('apexchart', vue_apexcharts_default.a);

vue_esm["default"].directive('sticky', vue_sticky_default.a);

vue_esm["default"].mixin(common);
vue_esm["default"].mixin(dates);

vue_esm["default"].use(src_api, {
  baseURL: "/api/private/",
  store: store
});

vue_esm["default"].use(checkout);

vue_esm["default"].use(dialogues);

vue_esm["default"].use(vee_validate_esm["a" /* default */], {
  i18n: config_i18n,
  i18nRootKey: 'validation'
});
validation(vee_validate_esm["a" /* default */]);

vue_esm["default"].prototype.$eventBus = new vue_esm["default"]();
// initNotifications(Vue.prototype.$eventBus)

store.dispatch('reLogin').then(function () {
  /* eslint-disable no-new */
  new vue_esm["default"]({
    el: '#app',
    provide: apolloProvider.provide(),
    router: src_router,
    i18n: config_i18n,
    template: '<App/>',
    components: { App: src_App },
    store: store
  });
});

/***/ }),

/***/ "NuBg":
/***/ (function(module, exports) {

module.exports = {"navigation":{"account":"Account","all":"All","analytics":"Analytics","dashboard":"Dashboard","deleted":"Deleted","draft":"Draft","expired":"Expired","help":"Help","login":"Log In","logout":"Log Out","managePayments":"Change subscription/payment details","new":"New","newsletter":"Newsletter | Newsletters","notification":"Notification","onboarding":"Onboarding","orders":"Order | Orders","payout":"Payout | Payouts","poll":"Poll | Polls","post":"Post | Posts","product":"Product | Products","profile":"Profile Page","published":"Published","purchase":"Purchase Details | Purchases","sales":"Sale | Sales","scheduled":"Scheduled","sent":"Sent","settings":"Settings","signup":"Sign Up","subscription":"Subscription | Subscriptions","tags":"Tag | Tags","vouchers":"Voucher|Vouchers"},"dashboard":{"empty":"No data available","timespans":{"thisMonth":"This Month","thisMonth_grammar":"this month","lastMonth":"Last Month","lastMonth_grammar":"last month","thisYear":"This Year","thisYear_grammar":"this year","lastYear":"Last Year","lastYear_grammar":"last year"},"quick_access":{"title":"Quick Access","subtitle":"Create new content now"},"followers":{"title":"Followers","subtitle":"Your current followers count","scopes":{"hour":"Hour","day":"Day","week":"Week","month":"Month","year":"Year"},"seriesNames":{"follower-active":"Active Followers"},"chart":{"title":"Follower History","subtitle":"Changes over Time"}},"subscribers":{"title":"Subscribers","subtitle":"Your current subscribers count"},"revenue":{"title":"Revenue","subtitle":"Expected revenue for this month"},"topsellers":{"title":"Top Sellers","subtitle":"Your {maxNumber} best selling items {period}","name":"Name","type":"Type","count":"Count","reward":"Subscription","product":"Product"},"artistReport":{"title":"Daily Activity Update","subtitle":"Receive a daily activity update via email to stay informed about your sales and followers. The email is only sent if there have been changes since the previous day.","label":"Daily Activity Update","info":"Enable this option to receive daily updates about your sales and followers from the previous day."}},"info":{"onboarding":{"stripe_missing":"You have not yet set up a Stripe account and cannot accept payments. Please go to <a href=\"{link}\">Onboarding</a> to complete the setup."},"profile":{"welcome":{"artist":"Why are you here? What can fans expect from you on this site? What's your motivation to expose your content here? A short bio about you, your mission or your work. Try to excite your fans with your content. Get your fans engaged.","user":"Welcome your visitors and tell them about you."},"imprint":"Like declared in the T&Cs under 5.4 you need to include consumer information and legal details to your clients. A proper legal statement includes:\n- Official Address (email for quick contact)\n- For companies/agencies: corporate name, registry ID, tax ID\n\nAnd don't miss to embed the link below regarding the EU online dispute resolution platform.","imprint_placeholder":"Define your imprint here.","tos":"Terms of Service","tos_placeholder":"Define your terms of service here.","privacy":"Privacy Policies","privacy_placeholder":"Define your privacy policies here.","hero_description":"Upload your page banner picture. First impressions count. The file size should not exceed {size} MB.","avatar_description":"Upload your profile picture. (Your smile, a band logo or your band pet). The file size shouldn´t exceed {size} MB.","social_links":"Link your social media accounts. Use your social media channels to excite your people about your getnext.to account.","imprint_settlement_notice":"As it is mandatory to provide a link to an online dispute resolution in your imprint, we recommend that the following text be included:<blockquote>Under the following link you will find the platform for online dispute resolution (ODR platform):<br>https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&lng=EN<br><br>The ODR Platform is an official website of the European Commission offering help to consumers and businesses to reach out-of-court settlements of disputes.</blockquote>","tos_voluntary_notice":"I would like to provide additional terms of service.","privacy_voluntary_notice":"I would like to provide additional additional privacy policies.","community":{"display":{"description":"Select here if the community should be shown to others in your profile.\nHowever, you can always see it when you are logged in."},"states":{"authenticated":{"label":"Authenticated","description":"The community is accessable to all logged-in users"},"follower":{"label":"Followers","description":"The community is accessable only to following fans"},"reward":{"label":"Subscribers","description":"The community is accessable only to subscribers"}}},"guestbook":{"display":{"description":"Select here if the guestbook should be shown to others in your profile.\nHowever, you can always see it when you are logged in."},"states":{"authenticated":{"label":"Authenticated","description":"The guestbook is accessable to all logged-in users"},"follower":{"label":"Followers","description":"The guestbook is accessable only to following fans"},"reward":{"label":"Subscribers","description":"The guestbook is accessable only to subscribers"}}},"branding_description":"Upload your logo image. It will be shown in your profile."},"product":{"header":"Click on product to edit","title":"Give your product a descriptive title. It should explain itself without loosing your personal note.","description":"Describe now what you offer to your fans. The better you explain your shop item the happier your fan will be. And don´t forget to describe in your typical words and style so that your fans feel immediately comfortable with your wording.","product_amount":"Set the fixed price of your product \nhere, or choose a minimum price and let \nyour fans decide. Never underestimate \nyour work.","available_stock":"You can create limited offers: For ex. physical goods, tickets, merchandise or premium offers.","publish_status":"Here you can define the status \nof your product: \n\n• Draft - Save for further editing.\nYou don´t have to publish your \nproduct straightaway.\nTake your time to create a \nperfect offer for your fans.\n\n• Scheduled - Plan ahead and \npublish while you are offline. \nYou can create your personal \ntime schedule for publishing \nyour items. You decide when \na product can go public. \n\n• Published - Now it´s getting \nexciting! If you use this option, \nyour product will be published \nimmediately.\n\nImportant: In contrary to \nregular subscriptions, \nyou can always change\nthe price of your product \nafter it´s published. \nIn case you are going to \ndelete (expire) the item, it \nwill remain valid to its buyers.","publish_date":"Set a specific publishing date for your product (DD/MM/YY)","publish_time":"Set a specific daytime the product will be published on the scheduled day (hh/mm)","media_files":"Upload an image visualising your product.\nPlease take your time for choosing your picture. This first impression is very important.","stock_information":"Items ordered: {orderedStock}, items remaining: {remainingStock}","remove_limitation":"Remove limitation","grant_withdrawal":"In the case of content that is immediately available to the user (or online tickets),\nthe right of revocation does not apply; the service cannot be returned.\n\nThe buyer must agree to this.\nIn the case of the sale of items without direct service, e.g. a t-shirt, the right of\nrevocation (14-day return) has to be granted.\n\nIf no immediate service arises from the purchase (digital content or ticket),\nplease activate this option.","additionalMedia":{"text":"Here you can optionally upload \nadditional media which may be \nused on different occasions, for \ninstance on landing pages. \nPlease upload up to 7 media \nitems to make the page as exciting \nas your product.","media_files":"Upload your original image, video, sound files (png, jpg, mp4, mov, mp3, wav,...)."},"depending_on":"This is where you decide if the purchase \nof this product requires another purchased item","expiration":{"confirm":{"title":"Are you sure to expire this product?","message":"<strong>You cannot undo this action.</strong>","depending":"Please consider detaching the following dependent products from this item before proceeding. In case you don't want to offer them at all without this item, you should terminate them first."}},"show_remaining_stock":"Remaining stock amount will be shown on the product page."},"subscription":{"header":"Click on subscription to edit","title":"Give your subscription a descriptive title. It should explain itself without loosing your personal note.","description":"Describe now what you offer to your fans and subscribers. The better you explain your subscription the happier your fan will be. And don´t forget to describe in your typical words and style so that your fans feel immediately comfortable with your wording.","reward_amount":"Set the monthly fee for your fan subscriptions.\nPlease consider exactly how much you want your fan to pay for your content.\nDon´t underestimate your work.","available_stock":"You can create limited offers: For ex. physical goods, tickets, merchandise or premium offers. User can't subscribe to limited offers and they are not included in any subscription level.","publish_status":"Here you can define the status of your subscription: \n\n• Draft - Save for further editing.\nYou don´t have to publish your subscription straightaway. Take your time to create a perfect offer for your fans. \n\n• Scheduled - Plan ahead and publish while you are offline.\nYou can create your personal time schedule for publishing your subscriptions. You decide when a subscription is published. \n\n• Published - Now it´s getting exciting!\nIf you use this option, your subscription will be published\nimmediately.\n\nImportant: You cannot change the price of your subscription after it´s published.\nIn case you are going to delete (expire) the subscription, it will remain valid to its buyers for one more month at most.","publish_date":"Set a specific publishing date \nfor your subscription \n(DD/MM/YY)","publish_time":"Set a specific daytime the \nsubscription will be published on the \nscheduled day (hh/mm)","media_files":"Upload an image visualising your subscription.\nPlease take your time for choosing your picture. This first impression is very important.","after_sale_question":"Would you like to ask your fans for \nimportant details like shipping address,\nclothing size or dedication text? \n- This is the right place to do so! \n\nYour questions will be provided to \nfuture buyers of this subscription.","additionalMedia":{"text":"Here you can optionally upload \nadditional media which may be \nused on different occasions, for \ninstance on landing pages. \nPlease upload up to 7 media \nitems to make the page as exciting \nas your subscription.","media_files":"Upload your original image, video, sound files (png, jpg, mp4, mov, mp3, wav,...)."},"rewardRecommendations":{"text":"You can recommend other active\nproduct here. Your recommendations \nwill show up on the landing page of this item.","noItemsAvailableYet":"No items available yet."},"expiration":{"confirm":{"title":"Are you sure to expire this subscription?","message":"<strong>You cannot undo this action.</strong>","depending":"Please consider detaching the following dependent products from this item before proceeding. In case you don't want to offer them at all without this item, you should terminate them first."}},"disable_mail_on_publish":"We will not send an email notification when you publish this item.","show_remaining_stock":"Remaining stock amount will be shown on the product page."},"post":{"header":"Click on post to edit","title":"Give your post a describing and strong title.","description":"Let your fans know what you do. Add text, images, video, sound and get your message out there.","livestream_url":"If you offer a third party livestream provider, \nlink the URL here.","external_url":"Link to external websites.","poll":"Easily create a poll for each posting to increase the fan engagement.\nYou find the results (public or not) in your profile menu.","publish_status":"Define the post status: \n• Draft - Save for further editing \n• Scheduled - Plan ahead and \npublish while offline \n• Published - Well done. Important: \nCheck before publishing - this can't \nbe undone!","publish_date":"Set the publishing date \nfor your post \n(DD/MM/YY).","publish_time":"Set a specific daytime \nfor your post on the scheduled day \n(hh/mm).","media_files":"Upload your original image, video, sound files (png, jpg, mp4, mov, mp3, wav,...).","access_control":"Who can see this post: every \nvisitor, all fans or only certain \nbuyers or subscribers?","select_reward":"Connect this post to specific subscription of your choice.","select_singleReward":"Connect this post to specific product of your choice.","sticky":"Use this function to hold your post \non top of your posts stream. \n\nSticky posts are ordered by\ntheir publishing dates.","follower_access":" Allow your followers to see this post for free.","tags":"Create or select tags...","no_tags":"There are no tags yet.","comments_enabled":"Enable the comment function to allow fan reactions"},"newsletter":{"header":"Click on newsletter to edit","title":"Give your newsletter a describing and strong title.","description":"Let your fans know what you do. Add text, images, video, sound and get your message out there.","livestream_url":"If you offer a third party livestream provider, \nlink the URL here.","external_url":"Link to external websites.","publish_status":"Define the newsletter status: \n• Draft - Save for further editing \n• Scheduled - Plan ahead and \npublish while offline \n• Published - Well done. Important: \nCheck before publishing - this can't \nbe undone!","publish_date":"Set the publishing date \nfor your newsletter \n(DD/MM/YY).","publish_time":"Set a specific daytime \nfor your newsletter on the scheduled day \n(hh/mm).","media_files":"Upload your original image, video, sound files (png, jpg, mp4, mov, mp3, wav,...).","access_control":"Who can see this newsletter: every \nvisitor, all fans or only certain \nbuyers or subscribers?","select_reward":"You may choose to send this\nnewsletter to holders of specific subscription.","select_singleReward":"You may choose to send\nthis newsletter to holders of\nspecific products.","follower_access":"Send this newsletter to all of your followers.","test_mail":{"title":"Test submission completed","message":"The test mail was sent to your email address. Please check your inbox."},"select_followers":"Select followers who permit sending emails","estimation":"This is the current number of recipients who match your criteria.","unfinished":"This newsletter is currently in sending state. There are {count} emails remaining.","deleted":"This newsletter was deleted. It is not editable anymore. As it was already published, we will keep the media alive for your fans.","uploading":"Upload processing - one moment, please...","send_testmail":"Send a test mail to yourself or send it to a custom email address.","test_mail_recipient_requirement":"In order to send a test mail\n, you need to schedule or publish the newsletter first.","sent":"This newsletter was sent. It is not editable anymore. As it was already published, we will keep the media alive for your fans.","send_with_reply":"You can add a \"reply-to\" header to receive responses from your fans.","newsletterRecommendations":{"text":"You can recommend other active\nsubscriptions or shop items here. Your recommendations \nwill be added to your email."}},"afterSale":{"question":"Would you like to ask your fans for important details like shipping address,\nclothing size or dedication text? - This is the right place to do so. \n\nYour questions will be provided to future buyers of this item.","buyer_description":"{name} has a message for you regarding this item","response_description":"Please answer as precisely as possible so that {name} can act in your best interest.","answer":"Send Answer","edit":"Edit Answer","cancel":"Cancel","thankYou":"Thank you very much for your answer. You wrote:","chars_left":"{count} characters left.","show_fan_message":"Show {user}'s message","hide_fan_message":"Hide {user}'s message","response":"Response"},"tags":{"header":"Tags","category":"Category","deletion":{"title":"Delete tag","message":"The tag \"{name}\" will be deleted an unlinked from all entities of its category. Proceed?","success":{"title":"Tag deleted","message":"The tag was deleted and unlinked from all entities of its category."}}},"poll":{"header":"Manage your poll results here"},"purchase":{"header":"Manage your purchases here","reward_expired_self":"This subscription expired on {date}. As you are the owner of this item, you are eligible for indefinite content access.","reward_expired":"This subscription was cancelled by {name} on {date}. You are eligible for accessing the content related to this item for the remaining time of your payment cycle.","deletion":{"confirmation":{"title":"Deletion submitted","message":"Your membership will be cancelled within the next minutes. You will receive an email about this change as well."}}},"payout":{"title":"My current revenue (this month)","header":"Manage your payouts here","revenue":"Your revenue of the current month\nincluding costs for payment transactions and market place fees (commissions)","net_income":"Your net income after portal fees have been duducted, less costs for payment transactions"},"orders":{"header":"Manage your orders here"},"account":{"your_phone_number":"Your phone number","phone_number_description_1":"Below you can choose to enter your phone number. We use this information to make it accessible to artists you follow.","phone_number_description_2":"By submitting your phone number, you agree to its sole use for actions of your followed profiles. Your phone number will be stored exclusively for this purpose.","phone_number_invalid":"Please provide a valid phone number."},"errors":{"standard":{"title":"Unexpected Error","message":"We are sorry to inform you that your request could not be processed. Please try again after a short period of time or contact us."},"post":{"save":{"title":"Error on saving your post","message":"We are sorry!\nYour post could not be saved. Please try again after a short period of time or contact us."}},"newsletter":{"save":{"title":"Error on saving your newsletter","message":"We are sorry!\nYour newsletter could not be saved. Please try again after a short period of time or contact us."}}}},"login":{"header":"Log In"},"divider":{"external_links":"My External Links","profile_options":"My Profile Options","legal_information":"My Legal Information","tos_information":"Terms of Service","privacy_information":"Privacy Policies"},"status":{"published":"Published","scheduled":"Scheduled","draft":"Draft","expired":"Expired","sent":"Sent","deleted":"Deleted"},"access":{"public":"Public","fans":"Fans Only","protected":"Protected"},"datepicker":{"startDate":"Start Date","endDate":"End Date","to":"to","lastWeek":"Last Week","lastMonth":"Last Month","last3Months":"Last 3 Months"},"misc":{"website":"Website","goto_public_profile":"(Go to my profile)","goto_profile":"Go to profile","future_profile_location":"Your public page will be found at:","copy_mail_address":"Copy mail address to clipboard","mail_address_copied":"Mail address copied to clipboard."},"list":{"no_match":"- no matching records -"},"label":{"nothing_found_here":"Nothing found here.","email":"Email","password":"Password","claim":"Name your claim or statement (today and tomorrow). What's your motto? What´s ”your personal headline”?","welcome_message":"Welcome Message","title":"Title","description":"Description","hero_image":"Banner Picture","avatar_image":"Profile Picture","disable_mail_on_publish":"Disable email notification on publish","display_artist_name":"Display your artist name on the hero image","display_claim":"Display your claim on the hero image","display_twitch_channel":"Display your Twitch channel in your profile","imprint":"Imprint","tos":"Terms of Service","privacy":"Privacy Policies","date":"Date","revenue":"Revenue","price_unit":"Price per Unit","price_month":"Price per Month","sales_count":"Sold Units","sales_remaining":"Remaining Units","subscriber_count":"Current Subscribers","name":"Name","artist":"Artist","fan":"Fan","singleReward":"Product","singleRewards":"Products","product":"Product","products":"Products","product_amount":"Price","reward":"Subscription","rewards":"Subscriptions","reward_description":"Subscription Description","reward_amount":"Subscription Amount","your_amount":"Your Amount","available_stock":"Available Stock","grant_withdrawal":"Grant right of revocation","limit_availability":"Limit Availabilty","publish_status":"Publish Status","publish_date":"Publish Date","publish_time":"Publish Time","post":"Post","newsletter":"Newsletter","assigned_to":"Assigned To","media":"Media","post_description":"Post Description","livestream":{"url":"Share Livestream URL","display_name":"Display Name (optional)"},"external_link":{"url":"Share External URL","display_name":"Display Name (optional)"},"access_control":"Access Control","select_rewards":"Select Subscriptions","select_singleRewards":"Select Products","select":"Select","selected":"Selected","remove":"Remove","poll":"Poll","poll_active":"Show Poll","poll_multiple":"Allow multiple answers","poll_max_answers":"Maximum number of answers","poll_question":"Poll Question","poll_option":"Poll Option | Poll Options","media_files":"Media Files","artist_name":"Name of the Artist","invoice_details":"Invoice Details","company":"Company","vat_number":"VAT Number","salutation":"Salutation","salutation_mr":"Mr.","salutation_mrs":"Mrs.","first_name":"First Name","last_name":"Last Name","street":"Street","zip":"ZIP code","city":"City","country":"Country","account_details":"Account Details","bank_account_owner":"Owner of the bank account","iban":"IBAN for payout","switch_language":"Switch Language to","no_media":"no media","no_poll":"no poll","receipt":"Receipt","payout":"Payout","portal_fee":"Portal Fee","payment_fee":"Payment Fee","payment_net":"Net Income","vote":"Vote | Votes","voter":"Voter | Voters","isEU":"Living in the EU","state":"Status","inactive":"Inactive","active":"active","validUntil":"Valid until","cancelled":"cancelled","asOf":"as of","terminated":"terminated","cancelledByMyself":"cancelled by myself","cancelledByArtist":"cancelled by artist","post_sticky":"Sticky Post","post_set_sticky":"Set this post sticky on top of your stream.","after_sale_question":"Retrieve additional information from your fans","additionalMedia":"Additional Media","view_landingpage":"View landing page","rewardRecommendations":"Recommend other items","display_avatar_mobile":"Display profile picture on smartphones","display_community":"Show community in profile","display_community_state":"Set the community access","display_guestbook":"Show guestbook in profile","display_guestbook_state":"Set the guestbook access","depending_on":"Item only available to holders of","follower_access":"Access for followers","send_to_followers":"Send to all followers","tags":"Keywords","phone":"Phone Number","subject":"Subject","send_to_nonbuyers":"Send to followers who currently have not purchased anything.","select_followers":"Select followers","estimated_recipients":"Estimated recipients","sending":"Sending","send_testmail":"Send test mail","send_testmail_address":"Send test mail to custom address","send_with_reply":"Send with reply-to address","send_reply_to_address":"Reply to email address","show_recommendations":"Show recommendations","n_selected":"{n} selected","newsletter_select_rewards":"Send to all followers who have the selected subscriptions","newsletter_select_singleRewards":"Send to all followers who have the selected shop items","newsletter_recommendations":"Recommend other items in your newsletter","branding_image":"Logo Image","comments_enabled":"Enable comments","show_remaining_stock":"Show remaining stock amount"},"button":{"submit":"Submit","save":"Save","savePreview":"Save and Preview","reset":"Reset","delete":"Delete","delete_account":"Delete Account","expire":"Expire","toExpire":"Expire","add_product":"Add Product","add_subscription":"Add Subscription","add_post":"Add Post","add_newsletter":"Add Newsletter","add_poll":"Add Poll","add_poll_option":"Add Poll Option","add_media":"Add Media File","edit_poll":"Edit Poll","cancel_reward":"Cancel Subscription","back":"Back","cancel":"Cancel","pricing":{"fixed":"Fixed Price","variable":"Variable Price"},"test_mail":"Test mail to my email address","send_now":"Send now","test_mail_to":"Test mail to {address}"},"confirm":{"reward":{"title":"You are almost ready!","text-1":"Please be aware that you cannot change the following parameters of a subscription once it has been \"published\":","text-2":"As long as your subscription is scheduled, you can edit all fields."},"product":{"title":"You are almost ready!","text-1":"Do you wish to save this product?"},"post":{"text-1":"Please be aware that you cannot change the following parameters of a post once it has been \"published\":","text-2":"As long as your post is scheduled, you can edit all fields."},"newsletter":{"text-1":"Here we inform you about the actions that will be triggered upon confirmation:","text-2":"\"Save\" does not send any emails (except when scheduling); \"Send now\" immediately sends the newsletter to all selected recipients. This action cannot be undone."},"unsaved":{"title":"Please confirm","message":"You may have unsaved changes here. Do you wish to proceed anyways?","ok":"Yes","cancel":"No"}},"validation":{"messages":{"_default":"The {0} value is not valid.","after":"The {0} must be after {1}.","alpha_dash":"The {0} field may contain alpha-numeric characters as well as dashes and underscores.","alpha_num":"The {0} field may only contain alpha-numeric characters.","alpha_spaces":"The {0} field may only contain alphabetic characters as well as spaces.","alpha":"The {0} field may only contain alphabetic characters.","before":"The {0} must be before {1}.","between":"The {0} field must be between {1}.","confirmed":"The {0} confirmation does not match.","credit_card":"The {0} field is invalid.","date_between":"The {0} must be between {1}.","date_format":"The {0} must be in the format {1}.","decimal":"The {0} field must be numeric and may contain {0} decimal points.","digits":"The {0} field must be numeric and exactly contain {0} digits.","dimensions":"The {0} field must be {1} pixels.","email":"The {0} field must be a valid email.","ext":"The {0} field must be a valid file.","image":"The {0} field must be an image.","in":"The {0} field must be a valid value.","integer":"The {0} field must be an integer.","ip":"The {0} field must be a valid ip address.","length":"The {0} length must be {1}.","max":"The {0} field may not be greater than {1} characters.","max_value":"The {0} field must be {1} or less.","mimes":"The {0} field must have a valid file type.","min":"The {0} field must be at least {1} characters.","min_value":"The {0} field must be {1} or more.","not_in":"The {0} field must be a valid value.","numeric":"The {0} field may only contain numeric characters.","regex":"The {0} field format is invalid.","required":"The {0} field is required.","size":"The {0} size must be less than {1}}.","url":"The {0} field is not a valid URL.","uniqueEmail":"This Email is already taken.","uniqueNickname":"This nickname is already taken."}},"account":{"delete":{"activeRewardNotification":{"title":"Cannot delete your account","heading":"Please cancel your active subscription offers.","message":"You need to cancel the following offered subscriptions before account deletion"},"activePledgeNotification":{"title":"Cannot delete your account","heading":"Please cancel your active subscriptions.","message":"You need to cancel the following purchased subscriptions before account deletion"},"confirmation":{"greeting":"Dear","goodbye":"It is hard to say goodbye","honey":"We are proud to have you as our member. Are you sure you really want to leave us?","artist":{"when":"Your account deletion will be completed after a grace period of one month."},"fan":{"when":"Your account will be deleted immediately after confirmation."}}},"deleted_user":"(Deleted User)"},"countries":{"af":"Afghanistan","al":"Albania","as":"American Samoa","ad":"Andorra","ao":"Angola","ai":"Anguilla","aq":"Antarctica","ag":"Antigua and Barbuda","ar":"Argentina","am":"Armenia","aw":"Aruba","at":"Austria","au":"Australia","az":"Azerbaijan","bs":"Bahamas","bh":"Bahrain","bd":"Bangladesh","bb":"Barbados","by":"Belarus","be":"Belgium","bz":"Belize","bj":"Benin","bm":"Bermuda","bt":"Bhutan","bo":"Bolivia","ba":"Bosnia and Herzegovina","bw":"Botswana","bv":"Bouvet Island","br":"Brazil","bn":"Brunei Darussalam","bg":"Bulgaria","bf":"Burkina Faso","bi":"Burundi","kh":"Cambodia","cm":"Cameroon","ca":"Canada","cv":"Cape Verde","ky":"Cayman Islands","cf":"Central African Republic","td":"Chad","cl":"Chile","cn":"China","co":"Colombia","km":"Comoros","cg":"Congo","ck":"Cook Islands","cr":"Costa Rica","ci":"Côte d\"Ivoire","hr":"Croatia","cu":"Cuba","cz":"Czech Republic","dk":"Denmark","dj":"Djibouti","do":"Dominican Republic","tp":"East Timor","ec":"Ecuador","eg":"Egypt","sv":"El salvador","gq":"Equatorial Guinea","er":"Eritrea","ee":"Estonia","et":"Ethiopia","fk":"Falkland Islands","fo":"Faroe Islands","fj":"Fiji","fi":"Finland","fr":"France","gf":"French Guiana","pf":"French Polynesia","ga":"Gabon","gm":"Gambia","ge":"Georgia","de":"Germany","gh":"Ghana","gi":"Gibraltar","gr":"Greece","gl":"Greenland","gd":"Grenada","gp":"Guadeloupe","gu":"Guam","gt":"Guatemala","gn":"Guinea","gy":"Guyana","ht":"Haiti","va":"Vatican","hn":"Honduras","hu":"Hungary","is":"Iceland","in":"India","id":"Indonesia","ir":"Iran","iq":"Iraq","ie":"Ireland","il":"Israel","it":"Italy","jm":"Jamaica","jp":"Japan","jo":"Jordan","kz":"Kazakstan","ke":"Kenya","ki":"Kiribati","kw":"Kuwait","kg":"Kyrgystan","la":"Lao","lv":"Latvia","lb":"Lebanon","ls":"Lesotho","li":"Liechtenstein","lt":"Lithuania","lu":"Luxembourg","mo":"Macau","mk":"Macedonia","mg":"Madagascar","mw":"Malawi","my":"Malaysia","mv":"Maldives","ml":"Mali","mt":"Malta","mr":"Mauritania","mu":"Mauritius","yt":"Mayotte","mx":"Mexico","fm":"Micronesia","md":"Moldova","mc":"Monaco","mn":"Mongolia","ms":"Montserrat","ma":"Morocco","mz":"Mozambique","mm":"Myanmar","na":"Namibia","nr":"Nauru","np":"Nepal","nl":"Netherlands","nz":"New Zealand","ni":"Nicaragua","ne":"Niger","ng":"Nigeria","nu":"Niue","nf":"Norfolk Island","kp":"North Korea","no":"Norway","om":"Oman","pk":"Pakistan","pw":"Palau","pa":"Panama","pg":"Papua New Guinea","py":"Paraguay","pe":"Peru","ph":"Philippines","pl":"Poland","pt":"Portugal","pr":"Puerto Rico","ro":"Romania","ru":"Russia","rw":"Rwanda","ws":"Samoa","sm":"San Marino","sa":"Saudi Arabia","sn":"Senegal","sc":"Seychelles","sl":"Sierra Leone","sg":"Singapore","sk":"Slovakia","sb":"Solomon Islands","so":"Somalia","za":"South Africa","kr":"South Korea","es":"Spain","lk":"Sri Lanka","sd":"Sudan","sr":"Suriname","sz":"Swaziland","se":"Sweden","ch":"Switzerland","sy":"Syriav","tw":"Taiwan","tj":"Tajikistan","tz":"Tanzania","th":"Thailand","tg":"Togo","to":"Tonga","tt":"Trinidad and Tobago","tn":"Tunisia","tr":"Turkey","tm":"Turkmenistan","tv":"Tuvalu","ug":"Uganda","ua":"Ukraine","ae":"United Arab Emirates","gb":"United Kingdom","us":"United States of America","uy":"Uruguay","uz":"Uzbekistan","vu":"Vanuatu","ve":"Venezuela","vn":"Vietnam","vg":"Virgin Islands","eh":"Western Sahara","ye":"Yemen","yu":"Yugoslavia","zr":"Zaire","zm":"Zambia","zw":"Zimbabwe"},"upload":{"errors":{"browserCannotPlayAudio":"Your Browser cannot play this audio file.","youCanFindItHere":"You can find it here"},"meta":{"displayName":"Display Name","displayNamePlaceholder":"Optional display name","description":"Description","descriptionPlaceholder":"Optional description"}},"uppy":{"selectToUpload":"Choose files to upload","closeModal":"Close modal","upload":"Upload","browse":"browse","dropPaste":"Drop file(s) here, or copy or {browse}","error":{"global":{"title":"Uploader Component Failed","description":"We are sorry, but your uploads could not be processed.\n Please try again."},"upload":{"title":"File Upload Failed","description":"We are sorry, but your file could not be processed.\n Please try again. "}}}}

/***/ }),

/***/ "OlBK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "ZO/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "scIF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-flag-icon/components/icon/Flag.vue
//
//
//
//
//
//
//

/* harmony default export */ var Flag = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b7d353","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-flag-icon/components/icon/Flag.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,attrs:{"title":_vm.title || _vm.iso}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var icon_Flag = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-flag-icon/components/icon/Flag.vue
function injectStyle (ssrContext) {
  __webpack_require__("MuD1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Flag,
  icon_Flag,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon_Flag = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tdkq":
/***/ (function(module, exports) {

module.exports = {"navigation":{"account":"Konto","all":"Alle","analytics":"Analyse","dashboard":"Dashboard","deleted":"Gelöscht","draft":"Entwurf","expired":"Beendet","help":"Hilfe","login":"Anmelden","logout":"Abmelden","managePayments":"Abo-/Zahlungsdaten ändern","new":"Neu","newsletter":"Newsletter | Newsletter","notification":"Benachrichtigungen","onboarding":"Onboarding","orders":"Bestellung | Bestellungen","payout":"Auszahlung | Auszahlungen","poll":"Umfrage | Umfragen","post":"Beitrag | Beiträge","product":"Produkt | Produkte","profile":"Profilseite","published":"Veröffentlicht","purchase":"Kauf | Käufe","sales":"Verkauf | Verkäufe","scheduled":"Geplant","sent":"Versendet","settings":"Einstellungen","signup":"Registrieren","subscription":"Abonnement | Abonnements","tags":"Schlagwort | Schlagwörter","vouchers":"Gutschein|Gutscheine"},"dashboard":{"empty":"Keine Daten verfügbar","timespans":{"thisMonth":"Dieser Monat","thisMonth_grammar":"in diesem Monat","lastMonth":"Letzter Monat","lastMonth_grammar":"des letzten Monats","thisYear":"Dieses Jahr","thisYear_grammar":"in diesem Jahr","lastYear":"Letztes Jahr","lastYear_grammar":"des letzten Jahres"},"quick_access":{"title":"Schnellwahl","subtitle":"Sofort neue Inhalte erstellen"},"followers":{"title":"Followers","subtitle":"Deine aktuelle Followers-Zahl","scopes":{"hour":"Stunde","day":"Tag","week":"Woche","month":"Monat","year":"Jahr"},"seriesNames":{"follower-active":"Aktive Follower"},"chart":{"title":"Follower-Historie","subtitle":"Veränderung über die Zeit"}},"subscribers":{"title":"Subscribers","subtitle":"Deine aktuellen Subscriber"},"revenue":{"title":"Umsatz","subtitle":"Dein für diesen Monat erwarteter Umsatz"},"topsellers":{"title":"Top Sellers","subtitle":"Deine {maxNumber} bestverkauften Artikel {period}","name":"Name","type":"Typ","count":"Anzahl","reward":"Abo","product":"Produkt"},"artistReport":{"title":"Tägliches Aktivitäts-Update","subtitle":"Erhalte täglich ein Aktivitäts-Update per E-Mail, damit Du stets über Deine Verkäufe und Follower informiert bist. Die E-Mail wird nur gesendet, wenn sich seit dem Vortag etwas geändert hat.","label":"Tägliches Aktivitäts-Update","info":"Aktiviere diese Option, um täglich Updates zu Deinen Verkäufen und Followern vom Vortag zu erhalten."}},"info":{"onboarding":{"stripe_missing":"Du hast noch kein Stripe-Konto eingerichtet und kannst keine Zahlungen annehmen. Bitte gehe zum <a href=\"{link}\">Onboarding</a>, um die Einrichtung abzuschließen."},"profile":{"welcome":{"artist":"Warum bist Du hier? Was ist Deine Motivation Deinen Fans hier Deinen Content anzubieten? Begrüße Deine Fans, was finden sie hier? Versuche hier Deine Fans zu begeistern sich mit Deinem Content zu beschäftigen.","user":"Warum bist Du hier? Begrüße Deine Besucher*innen und schreibe etwas über Dich."},"imprint":"Wie in den AGBs unter 5.4 erwähnt, bist Du zur Angabe eines Impressums verpflichtet. Ein korrektes Impressum umfasst:\n- Kontakt-Anschrift (+ Email für schnellen Kontakt)\n- Wenn Du eine Gewerbe hast: Rechtsform, Amtsregister, Registernummer, USt-ID\n\nUnd vergiss nicht die Einbindung des Links unten zur EU Online-Streitbeilegung.","imprint_placeholder":"Erstelle Dein Impressum hier.","tos":"Allgemeine Geschäftsbedingungen","tos_placeholder":"Hier ist Platz für Deine Allgemeinen Geschäftsbedingungen.","privacy":"Datenschutzbestimmungen","privacy_placeholder":"Hier ist Platz für Deine Datenschutzbestimmungen.","hero_description":"Lade ein Begrüßungsbild hoch. Der erste Eindruck zählt. Die Dateigröße sollte nicht mehr als {size} MB betragen.","avatar_description":"Hier lädst Du Dein Profilbild hoch (ein Portrait, Dein Logo oder das Bild Deines Maskottchens). Die Bildgröße sollte nicht mehr als {size} MB betragen.","social_links":"Verlinke einfach Deine Social-Media-Accounts. Nutze Deine Social-Media-Accounts, um auf Deine Präsenz bei getnext.to aufmerksam zu machen.","imprint_settlement_notice":"Da die Einbindung eines Links zur Online-Streitbeilegung im Impressum verpflichtend ist, empfehlen wir folgenden Text ins Impressum zu übernehmen:<blockquote>Unter nachfolgendem Link finden Sie die Plattform zur Online-Streitbeilegung (ODR-Plattform):<br>https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home.show&lng=DE<br><br>Die ODR-Plattform ist eine offizielle Webseite der Europäischen Kommission, die Verbrauchern und Unternehmern hilft, bei Problemen zu einer außergerichtlichen Einigung zu kommen.</blockquote>","tos_voluntary_notice":"Ich möchte zusätzlich Geschäftsbedingungen formulieren.","privacy_voluntary_notice":"Ich möchte zusätzlich Datenschutzbestimmungen formulieren.","community":{"display":{"description":"Wähle hier aus, ob Deine Besucher:innen die Community in Deinem Profil sehen sollen.\nDu kannst sie jedoch immer sehen, wenn Du eingeloggt bist."},"states":{"authenticated":{"label":"Eingeloggt","description":"Die Community ist sichtbar für alle eingeloggten Benutzer"},"follower":{"label":"Follower","description":"Die Community ist sichtbar für Fans, die Dir folgen"},"reward":{"label":"Abonnenten","description":"Die Community ist sichtbar für Abonnenten"}}},"guestbook":{"display":{"description":"Wähle hier aus, ob Deine Besucher das Gästebuch in Deinem Profil sehen sollen.\nDu kannst sie jedoch immer sehen, wenn Du eingeloggt bist."},"states":{"authenticated":{"label":"Eingeloggt","description":"Das Gästebuch ist sichtbar für eingeloggte Besucher"},"follower":{"label":"Follower","description":"Das Gästebuch ist sichtbar für Fans, die Dir folgen"},"reward":{"label":"Abonnenten","description":"Das Gästebuch ist sichtbar für Abonnenten"}}},"branding_description":"Lade Dein Logo hoch. Es wird in Deinem Profil verwendet."},"subscription":{"header":"Klicken, um das Produkt zu ändern","title":"Gib Deinem Produkt einen Namen. Er sollte selbsterklärend sein und trotzdem Deine Handschrift besitzen.","description":"Beschreibe jetzt, was Du Deinen Fans mit diesem Abo alles anbietest. Je klarer und ausführlicher Du dies machst, desto mehr freut sich Dein Fan. Auch hier solltest Du Deine Wortwahl und Deine persönliche Note wählen.","reward_amount":"Hier legst Du den monatlichen Preis für das Abo fest.\nDenke genau über die Höhe des Betrags nach und \nunterschätze Deinen Content nicht.","available_stock":"Du kannst auch begrenzte Angebote einstellen wie z.B. bei Tickets, Merchandise usw. Nutzer*innen können limitierte Angebote nicht abonnieren und sie können nicht in einem Abo inkludiert sein.","publish_status":"Hier kannst du den Status deiner Abos definieren: \n\n• Entwurf - Du musst nicht sofort Dein Abo \nfreischalten. Nimm Dir die Zeit Dein Angebot optimal \nzu definieren.\n\n• Geplant - Veröffentlichung folgt zu einem definierten \nZeitpunkt. Du kannst im Voraus planen, wann das Angebot \nonline erscheint.\n\n• Direkte Veröffentlichung - Jetzt wird es spannend!\nDein Abo nwird sofort sichtbar und kann abgeschlossen werden.\n\nAchte darauf: Nach Veröffentlichung bleibt die Gültigkeit \nbereits bestehender Abonnenments für maximal einen weiteren \nMonat erhalten.","publish_date":"Hier legst Du das Datum für eine Veröffentlichung fest (TT/MM/JJ).","publish_time":"Hier legst Du die Uhrzeit für eine Veröffentlichung fest. (Stunde/Minute).","media_files":"Wähle ein passendes Bild für Dein Angebot. Der erste Eindruck ist wichtig.","after_sale_question":"Möchtest Du wichtige Informationen von Deinen Fans erfragen?\nHier ist der richtige Ort, um zum Beispiel nach einer Versandadresse, Wunschgröße oder Widmung zu fragen.\n\nDeine Fragen werden den zukünftigen Abonnenten angezeigt.","additionalMedia":{"text":"Hier kannst Du optional weitere \nMedien hinzufügen, die an \nverschiedenen Stellen zum Einsatz \nkommen können, zum Beispiel \nauf Landing Pages. \n\nLade bitte bis zu 7 weitere Medien \nhoch, um die Seite genauso \naufregend wie Dein Angebot \nzu machen.","media_files":"Du kannst aktuell folgende Medien hochladen: Bilder"},"rewardRecommendations":{"text":"Du kannst hier andere aktive \nProdukte empfehlen. \n\nDeine Empfehlungen werden auf der \nLanding Page dieses Abos zu \nsehen sein.","noItemsAvailableYet":"Keine Elemente bisher verfügbar"},"expiration":{"confirm":{"title":"Möchtest Du dieses Abo-Angebot wirklich beenden?","message":"<strong>Du kannst diesen Vorgang nicht rückgängig machen.</strong>","depending":"Bitte denke daran, die folgenden anbhängigen Produkte von diesem Abo zu lösen, bevor Du fortfährtst. Falls Du sie ohne dieses Abo gar nicht anbieten möchtest, kannst Du sie zuerst beenden."}},"disable_mail_on_publish":"Wir senden keine E-Mail-Benachrichtigung bei Veröffentlichung","show_remaining_stock":"Verbleibender Bestand wird auf der Produktseite angezeigt"},"product":{"header":"Klicken, um das Produkt zu ändern","title":"Gib Deinem Produkt einen Namen. Er sollte selbsterklärend sein und trotzdem Deine Handschrift besitzen.","description":"Beschreibe jetzt, was Du Deinen Fans durch dieses Produkt alles anbietest. Je klarer und ausführlicher Du dies machst, desto mehr freut sich Dein Fan. Auch hier solltest Du Deine Wortwahl und Deine persönliche Note wählen.","product_amount":"Hier legst Du den Preis für den \nArtikel fest. Du kannst Dich \nzwischen einem Festpreis und einem \nMindestpreis entscheiden. Denke genau \nüber den Preis nach und unterschätze \nDeinen Content nicht.","available_stock":"Du kannst auch begrenzte Angebote einstellen wie z.B. bei Tickets, Merchandise usw.","publish_status":"Hier kannst du den Status deines Artikels \ndefinieren: \n\n• Entwurf - Du musst nicht sofort den Artikel \nfreischalten.Nimm Dir die Zeit, Dein Angebot \noptimal zu definieren.\n\n• Geplant - Veröffentlichung folgt zu einem definierten \nZeitpunkt. Du kannst im Voraus planen, wann Produkte \nonline erscheinen.\n\n• Direkte Veröffentlichung - Jetzt wird es spannend!\nDein Angebot \nwird sofort sichtbar und kann gekauft werden.","publish_date":"Hier legst Du das Datum für eine Veröffentlichung fest (TT/MM/JJ).","publish_time":"Hier legst Du die Uhrzeit für eine Veröffentlichung fest. (Stunde/Minute).","media_files":"Wähle ein passendes Teaser-Bild für diesen Artikel. Der erste Eindruck ist wichtig.","stock_information":"Artikel bestellt: {orderedStock}, Artikel übrig: {remainingStock}","remove_limitation":"Limitierung entfernen","grant_withdrawal":"Bei Inhalten, die Deinen Fans sofort zur Verfügung stehen (oder Online-Tickets), entfällt das\nRecht auf Widerruf; die Leistung kann nicht zurückgegeben werden.\n\nDazu muss der/die Käufer*in zustimmen.\n\nBei dem Verkauf von Gegenständen ohne direkte Leistung, z.B. bei einem T-Shirt, muss ein\nWiderrufsrecht (14 Tage Rückgabe) eingeräumt werden.\n\nWenn Deine Inhalte nicht sofort nach dem Kauf verfügbar sind (zum Beispiel noch versendet werden müssen), bitte\ndiese Option aktivieren.","additionalMedia":{"text":"Hier kannst Du optional weitere \nMedien hinzufügen, die an \nverschiedenen Stellen zum Einsatz \nkommen können, zum Beispiel auf \nLanding Pages. \n\nLade bitte bis zu 7 weitere Medien \nhoch, um die Seite genauso \naufregend wie Dein Produkt \nzu machen.","media_files":"Du kannst aktuell folgende Medien hochladen: Bilder"},"depending_on":"Hier entscheidest Du, ob der Erwerb dieses Artikels \nden Kauf eines anderen Produktes voraussetzt.","expiration":{"confirm":{"title":"Möchtest Du dieses Angebot wirklich beenden?","message":"<strong>Du kannst diesen Vorgang nicht rückgängig machen.</strong>","depending":"Bitte denke daran, die folgenden anbhängigen Produkte von diesem Artikel zu lösen, bevor Du fortfährtst. Falls Du sie ohne diesen Artikel gar nicht anbieten möchtest, kannst Du sie zuerst beenden."}},"show_remaining_stock":"Verbleibender Bestand wird auf der Produktseite angezeigt"},"post":{"header":"Klicken, um den Beitrag zu ändern","title":"Wähle einen schlagkräftigen Titel.","description":"Hier ist Platz für Text, Bild, Sound und Video.","livestream_url":"Solltest Du einen Live-Streaming-Link haben, \nkannst Du ihn hier einbinden.","external_url":"Verlinke externe Webseiten","poll":"Erstelle einfach eine Umfrage, \num Deine Fans zu involvieren. \n\nDu findest die Ergebnisse (egal, \nob öffentlich oder versteckt) \nin Deiner Profilansicht.","publish_status":"Wie ist der Status Deines Beitrages: \n• Entwurf - Speichern zum Editieren \n• Geplant - Veröffentlichung folgt später \n• Direkte Veröffentlichung - Achte darauf: \nEinen veröffentlichten \nBeitrag kannst Du zwar \nverändern, jedoch nicht mehr entfernen.","publish_date":"Hier legst Du das Datum für \neine Veröffentlichung fest \n(TT/MM/JJ).","publish_time":"Hier legst Du die Uhrzeit für \neine Veröffentlichung fest \n(Stunde/Minute).","media_files":"Du kannst diverse Medien hochladen: Bilder, Sounds, Videos usw.","access_control":"Wer darf den Beitrag sehen: Alle Besucher*innen, alle oder nur bestimmte Abonennt*innen","select_reward":"Wähle die Abos aus, denen Du \ndiesem Beitrag zuordnen möchtest.","select_singleReward":"Wähle die Shop-Artikel aus, \ndie Du diesem Beitrag zuorden möchtest.","sticky":"Nutze die Funktion, um diesen \nBeitrag dauerhaft oben in \nDeinem Stream zu halten.\nAngeheftete Beiträge werden \nnach ihrem\nVeröffentlichungsdatum sortiert.","follower_access":"Erlaube Deinen Followern, diesen Post kostenfrei zu sehen.","tags":"Erstelle oder wähle Schlagwörter...","no_tags":"Bisher gibt es noch keine Schlagwörter.","comments_enabled":"Aktiviere die Kommentarfunktion, damit Deine Fans reagieren können"},"newsletter":{"header":"Klicken, um den Newsletter zu ändern","title":"Wähle einen schlagkräftigen Betreff.","description":"Hier ist Platz für Text und Bilder.","publish_status":"Wie ist der Status Deines Newsletters: \n• Entwurf - Speichern zum Editieren \n• Geplant - Versand folgt später \n• Direkter Versand - Achte darauf: \nEinen veröffentlichten \nNewsletter kannst Du zwar \nverändern bereits versendete E-Mails jedoch nicht.","publish_date":"Hier legst Du das Datum für \ndie Veröffentlichung (und den Versand) fest \n(TT/MM/JJ).","publish_time":"Hier legst Du die Uhrzeit für \neine Veröffentlichung (und den Versand) fest \n(Stunde/Minute).","select_reward":"Wähle die Abos aus, deren Mitglieder\nden Newsletter erhalten sollen.","select_singleReward":"Wähle die Shop-Artikel aus, \nderen Besitzer*innen diesen Newsletter\nerhalten sollen.","follower_access":"Sende diesen Newsletter allen aktiven Followern.","test_mail":{"title":"Testversand durchgeführt","message":"Der Testversand wurde erfolgreich durchgeführt. Bitte überprüfe Dein E-Mail-Postfach."},"select_followers":"Wähle Follower aus, die E-Mail-Versand erlauben","estimation":"Dies ist die ungefähre Anzahl an E-Mails, die wir versenden werden.","unfinished":"Dieser Newsletter wird gerade verarbeitet. Es stehen noch {count} E-Mails aus.","deleted":"Dieser Newsletter wurde gelöscht. Da er bereits publiziert war, halten wir die Daten online.","uploading":"Upload läuft - einen Moment, bitte...","send_testmail":"Sende eine Test-E-Mail an Dich selbst oder optional an einer definierte E-Mail-Adresse.","test_mail_recipient_requirement":"Um eine Test-E-Mail zu versenden, muss der \nNewsletter zuvor \"geplant\" oder \"veröffentlicht\" werden.","sent":"Dieser Newsletter wurde versendet. Da er bereits publiziert war, halten wir die Daten online.","send_with_reply":"Du kannst hier eine „Antwort-an“-Kopfzeile hinzufügen, um Antworten von Deinen Fans zu empfangen.","newsletterRecommendations":{"text":"Du kannst hier andere aktive \nAbos/Produkte empfehlen. \n\nDeine Empfehlungen werden auf der \nin Deiner E-Mail angefügt."}},"afterSale":{"question":"Möchtest Du wichtige Informationen von \nDeinen Fans erfragen?\nHier ist der richtige Ort, um \nzum Beispiel nach einer Versandadresse, \nWunschgröße oder Widmung zu fragen.\n\nDeine Fragen werden den zukünftigen \nKäufer*innen dieses Artikels angezeigt.","buyer_description":"{name} hat Dir für diesen Artikel eine Nachricht hinterlassen","response_description":"Bitte antworte so präzise wie möglich, damit {name} in Deinem Sinne bestmöglich handeln kann.","answer":"Antworten","edit":"Antwort bearbeiten","cancel":"Abbrechen","thankYou":"Vielen Dank für Deine Antwort. Sie lautete:","chars_left":"{count} Zeichen übrig.","show_fan_message":"{user}s Nachricht anzeigen","hide_fan_message":"{user}s Nachricht ausblenden","response":"Antwort"},"tags":{"header":"Schlagwörter","category":"Kategorie","deletion":{"title":"Schlagwort löschen","message":"Das Schlagwort \"{name}\" wird gelöscht und von allen verbundenen Elementen seiner Kategorie entfernt. Fortfahren?","success":{"title":"Schlagwort gelöscht","message":"Das Schlagwort wurde gelöscht und von allen verbundenen Elementen seiner Kategorie entfernt."}}},"poll":{"header":"Verwalte Deine Umfrageergebnisse hier"},"purchase":{"header":"Verwalte Deine Einkäufe hier","reward_expired_self":"Dieses Abo wurde am {date} beendet. Da Du selbst Besitzer*in des Artikels bist, hast Du weiterhin unbegrenzten Zugriff.","reward_expired":"Dieses Abonnement wurde von {name} am {date} beendet. Für den Zeitraum Deiner aktuellen Buchungsperiode behälst Du weiterhin Zugriff auf die verbundenen Inhalte.","deletion":{"confirmation":{"title":"Löschung vorbereitet","message":"Deine Mitgliedschaft wird in diesen Minuten beendet. Du wirst zusätzlich eine E-Mail von uns bekommen."}}},"payout":{"title":"Aktueller Umsatz (diesen Monat)","header":"Verwalte Deine Auszahlungen hier","revenue":"Deine Einnahmen in diesem Monat\ninkl. Transaktions- und Marktplatzgebühren (Provision)","net_income":"Deine Netto-Einnahmen nach Abzug der Portal-Gebühren, Transaktionskosten noch nicht berücksichtigt"},"orders":{"header":"Verwalte Deine Bestellungen hier"},"account":{"your_phone_number":"Deine Telefonnummer","phone_number_description_1":"Nachfolgend hast Du die Möglichkeit, freiwillig Deine Telefonnumer zu hinterlegen. Diese Information verwenden wir, um sie Künstlerinnen und Künstlern zugänglich zu machen, denen Du folgst.","phone_number_description_2":"Mit der Übermittlung der Telefonnummer stimmst Du ausschließlich ihrer Verwertung für Aktionen der Profile zu, denen Du folgst. Deine Telefonummer wird ausschließlich zu diesem Zweck gepeichert.","phone_number_invalid":"Bitte gebe eine gültige Telefonnummer an."},"errors":{"standard":{"title":"Fehler","message":"Deine Anfrage konnte aufgrund eines Fehlers leider nicht verarbeitet werden. Bitte versuche es erneut oder nimm Kontakt zu uns auf."},"post":{"save":{"title":"Fehler beim Speichern","message":"Es tut uns leid!\nDer Beitrag konnte nicht gespeichert werden. Bitte versuche es nach kurzer Zeit erneut oder nimm Kontakt zu uns auf."}},"newsletter":{"save":{"title":"Fehler beim Speichern","message":"Es tut uns leid!\nDer Newsletter konnte nicht gespeichert werden. Bitte versuche es nach kurzer Zeit erneut oder nimm Kontakt zu uns auf."}}}},"login":{"header":"Anmelden"},"divider":{"external_links":"Meine externen Links","profile_options":"Meine Profil-Optionen","legal_information":"Meine rechtlichen Informationen","tos_information":"Allgemeine Geschäftsbedingungen","privacy_information":"Datenschutzbestimmungen"},"status":{"published":"Veröffentlicht","scheduled":"Geplant","draft":"Entwurf","expired":"Beendet","sent":"Versendet","deleted":"Gelöscht"},"access":{"public":"Öffentlich","fans":"Nur für Fans","protected":"Geschützt"},"datepicker":{"startDate":"Startdatum","endDate":"Enddatum","to":"bis","lastWeek":"Letzte Woche","lastMonth":"Letzter Monat","last3Months":"Letzte 3 Monate"},"misc":{"website":"Website","goto_public_profile":"(zum Profil gehen)","goto_profile":"Zum Profil gehen","future_profile_location":"Deine öffentliche Seite findest Du zukünftig unter:","copy_mail_address":"E-Mail-Adresse in die Zwischenablage kopieren","mail_address_copied":"E-Mail-Adresse in die Zwischenablage kopiert."},"list":{"no_match":"- kein passender Eintrag -"},"label":{"nothing_found_here":"Nichts gefunden.","email":"Email","password":"Passwort","claim":"Was ist Dein Motto heute (morgen und übermorgen)? Wofür stehst Du? Was ist Dein Motto? Was möchtest Du kurz und knapp als ”Deine persönliche Überschrift” haben?","welcome_message":"Willkommenstext","title":"Titel","description":"Beschreibung","hero_image":"Begrüßungsbild","avatar_image":"Profilbild","disable_mail_on_publish":"Keine E-Mail-Benachrichtigung bei Veröffentlichung","display_artist_name":"Deinen Künstler-/Künstlerinnennamen auf dem Banner-Bild darstellen","display_claim":"Dein Motto auf dem Banner-Bild darstellen","display_twitch_channel":"Deinen Twitch-Kanal im Profil darstellen","imprint":"Impressum","tos":"Allgemeine Geschäftsbedingungen","privacy":"Datenschutzbestimmungen","date":"Datum","price_unit":"Einzelpreis","revenue":"Umsatz","price_month":"Preis pro Monat","sales_count":"Verkaufte Einheiten","sales_remaining":"Übrige Einheiten","subscriber_count":"Momentane Abonnent*innen","name":"Name","artist":"Künstler*in","fan":"Fan","singleReward":"Produkt","singleRewards":"Produkte","product":"Produkt","products":"Produkte","product_amount":"Preis","reward":"Abo","rewards":"Abos","reward_description":"Beschreibung des Abos","reward_amount":"Betrag des Abos","your_amount":"Dein Betrag","available_stock":"Verfügbare Einheiten","limit_availability":"Begrenzte Verfügbarkeit","grant_withdrawal":"Widerrufsrecht einräumen","publish_status":"Status der Veröffentlichung","publish_date":"Veröffentlichungsdatum","publish_time":"Veröffentlichungszeit","post":"Post","newsletter":"Newsletter","assigned_to":"Zugewiesen zu","media":"Medien","post_description":"Beschreibung des Beitrags","livestream":{"url":"Livestream URL teilen","display_name":"Anzeigetext (optional)"},"external_link":{"url":"Ausgehenden Link teilen","display_name":"Anzeigetext (optional)"},"access_control":"Zugriffskontrolle","select_rewards":"Abos auswählen","select_singleRewards":"Shop-Artikel auswählen","select":"Auswählen","selected":"Ausgewählt","remove":"Entfernen","poll":"Umfrage","poll_active":"Umfrage anzeigen","poll_multiple":"Mehrfachauswahl zulassen","poll_max_answers":"Maximale Anzahl an Antworten","poll_question":"Frage der Umfrage","poll_option":"Umfrage Option | Umfrage Optionen","media_files":"Medien","artist_name":"Künstler-/Künstlerinname","invoice_details":"Rechungsdaten","company":"Firma","vat_number":"Umsatzsteuer ID Nummer","salutation":"Anrede","salutation_mr":"Herr","salutation_mrs":"Frau","first_name":"Vorname","last_name":"Nachname","street":"Straße","zip":"Postleitzahl","city":"Stadt","country":"Land","account_details":"Kontodetails","bank_account_owner":"Inhaber*in des Bankkontos","iban":"IBAN für Auszahlungen","switch_language":"Wechsel zu","no_media":"Keine Medien","no_poll":"Keine Umfrage","receipt":"Eingang","payout":"Auszahlung","portal_fee":"Portalgebühr","payment_fee":"Zahlungsgebühren","payment_net":"Netto-Einnahmen","vote":"Stimme | Stimmen","voter":"Wähler | Wähler","isEU":"Adresse in der EU","state":"Status","inactive":"Inaktiv","active":"Aktiv","validUntil":"Gültig bis","cancelled":"gekündigt","asOf":"zum","terminated":"beendet","cancelledByMyself":"selbst gekündigt","cancelledByArtist":"von Künstler*in gekündigt","post_sticky":"Angehefteter Beitrag","post_set_sticky":"Diesen Beitrag im Stream oben anheften","after_sale_question":"Frage Deine Fans nach weiteren Informationen","additionalMedia":"Weitere Medien","view_landingpage":"Landingpage ansehen","rewardRecommendations":"Empfiehl weitere Produkte","display_avatar_mobile":"Profilbild auf Smartphones anzeigen","display_community":"Community im Profil anzeigen","display_community_state":"Wähle den Community-Zutritt","display_guestbook":"Gästebuch im Profil anzeigen","display_guestbook_state":"Wähle den Gästebuch-Zutritt","depending_on":"Nur verfügbar für Fans mit folgenden Abos/Produkten","follower_access":"Zugriff für Follower","send_to_followers":"Sende an alle Follower","tags":"Schlagwörter","phone":"Telefonnummer","subject":"Betreff","send_to_nonbuyers":"Sende an Follower, die aktuell nichts gekauft haben","select_followers":"Follower auswählen","estimated_recipients":"Geschätzte Empfängeranzahl","sending":"Im Versand","send_testmail":"Test-E-Mail versenden","send_testmail_address":"Test-E-Mail an eine andere Adresse senden","send_with_reply":"Senden mit Antwortadresse","send_reply_to_address":"An folgende E-Mail-Adresse antworten","show_recommendations":"Empfehlungen anzeigen","n_selected":"{n} ausgewählt","newsletter_select_rewards":"Sende an alle Follower mit den ausgewählten Abos","newsletter_select_singleRewards":"Sende an alle Follower mit den ausgewählten Produkten","newsletter_recommendations":"Empfiehl Deine Produkte im Newsletter","branding_image":"Logo","comments_enabled":"Kommentare aktivieren","show_remaining_stock":"Verbleibenden Bestand darstellen"},"button":{"submit":"Bestätigen","save":"Speichern","savePreview":"Speichern und Vorschau","reset":"Zurücksetzen","delete":"Löschen","delete_account":"Konto löschen","expire":"Beendet","toExpire":"Beenden","add_product":"Produkt hinzufügen","add_subscription":"Abo hinzufügen","add_post":"Beitrag hinzufügen","add_newsletter":"Newsletter hinzufügen","add_poll":"Umfrage hinzufügen","add_poll_option":"Umfrageoption hinzufügen","add_media":"Medien hinzufügen","edit_poll":"Umfrage bearbeiten","cancel_reward":"Abo kündigen","back":"Zurück","cancel":"Abbrechen","pricing":{"fixed":"Festpreis","variable":"Variabler Preis"},"test_mail":"Testversand an meine E-Mail-Adresse","send_now":"Jetzt senden","test_mail_to":"Testversand an {address}"},"confirm":{"reward":{"title":"Du hast es fast geschafft!","text-1":"Achtung! Sobald ein Abo veröffentlicht wurde, kannst Du die folgenden Parameter nicht mehr ändern:","text-2":"Solange das Abo auf ”geplant” eingestellt ist, kannst Du es noch verändern."},"product":{"title":"Du hast es fast geschafft!","text-1":"Möchtest Du dieses Produkt speichern?"},"post":{"text-1":"Achtung! Sobald ein Beitrag veröffentlicht wurde, kannst Du die folgenden Parameter nicht mehr ändern:","text-2":"Solange der Beitrag auf ”geplant” eingestellt ist, kannst Du ihn noch verändern."},"newsletter":{"text-1":"Achtung! Nachfolgend informieren wir Dich über die Aktionen, die bei Bestätigung angestoßen werden:","text-2":"\"Speichern\" versendet keine E-Mails (außer wenn \"geplant\"); \"Jetzt senden\" versendet den Newsletter sofort an alle gewählten Adressaten. Dies kann nicht rückgängig gemacht werden."},"unsaved":{"title":"Bitte bestätigen","message":"Du hast hier eventuell ungespeicherte Inhalte. Möchtest Du dennoch fortfahren?","ok":"Ja","cancel":"Nein"}},"validation":{"messages":{"_default":"{0} ist ungültig.","after":"{0} muss nach {1} liegen.","alpha_dash":"{0} darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten.","alpha_num":"{0} darf nur alphanumerische Zeichen enthalten.","alpha":"{0} darf nur alphabetische Zeichen enthalten.","before":"{0} muss vor {1} liegen.","between":"{0} muss zwischen {1} liegen.","confirmed":"{0} passt nicht zum Inhalt von {1}}.","date_between":"{0} muss zwischen {1} liegen.","date_format":"{0} muss das Format {1} haben.","decimal":"{0} muss numerisch sein und darf {1} Dezimalpunkte enthalten.","digits":"{0} muss numerisch sein und exakt {1} Ziffern enthalten.","dimensions":"{0} muss {1} Bildpunkte groß sein.","email":"{0} muss eine gültige E-Mail-Adresse sein.","ext":"{0} muss eine gültige Datei sein.","image":"{0} muss eine Grafik sein.","in":"{0} muss ein gültiger Wert sein.","ip":"{0} muss eine gültige IP-Adresse sein.","max":"{0} darf nicht länger als {1} Zeichen sein.","mimes":"{0} muss einen gültigen Dateityp haben.","min":"{0} muss mindestens {1} Zeichen lang sein.","not_in":"{0} muss ein gültiger Wert sein.","numeric":"{0} darf nur numerische Zeichen enthalten.","regex":"Das Format von {0} ist ungültig.","required":"{0} ist ein Pflichtfeld.","size":"{0} muss kleiner als {1} sein.","url":"{0} ist keine gültige URL.","uniqueEmail":"Die Email ist bereits vergeben.","uniqueNickname":"Der Name ist bereits vergeben."}},"account":{"delete":{"activeRewardNotification":{"title":"Account-Löschung nicht möglich","heading":"Bitte beende Deine aktiven angebotenen Abonnements","message":"Die folgenden durch Dich angebotenen Abos müssen beendet werden, bevor Du Dein Konto löschen kannst."},"activePledgeNotification":{"title":"Account-Löschung nicht möglich","heading":"Bitte beende Deine aktiven gekauften Abonnements","message":"Die folgenden Abos müssen beendet werden, bevor Du Dein Konto löschen kannst."},"confirmation":{"greeting":"Hallo","goodbye":"Dein Abschied schmerzt...","honey":"wir sind stolz, Dich bei uns zu haben. Bist Du Dir wirklich sicher, dass Du uns verlassen möchtest?","artist":{"when":"Die Löschung Deines Kontos wird nach einer Übergangszeit von einem Monat vollzogen."},"fan":{"when":"Dein Konto wird nach Deiner Bestätigung mit sofortiger Wirkung gelöscht."}}},"deleted_user":"(Gelöschte/r Benutzer*in)"},"countries":{"af":"Afghanistan","al":"Albanien","as":"Amerikanisch Samoa","ad":"Andorra","ao":"Angola","ai":"Anguilla","aq":"Antarktis","ag":"Antigua und Barbuda","ar":"Argentinien","am":"Armenien","aw":"Aruba","at":"Österreich","au":"Australien","az":"Aserbaidschan","bs":"Bahamas","bh":"Bahrain","bd":"Bangladesh","bb":"Barbados","by":"Weißrussland","be":"Belgien","bz":"Belize","bj":"Benin","bm":"Bermuda","bt":"Bhutan","bo":"Bolivien","ba":"Bosnien Herzegowina","bw":"Botswana","bv":"Bouvet Island","br":"Brasilien","bn":"Brunei Darussalam","bg":"Bulgarien","bf":"Burkina Faso","bi":"Burundi","kh":"Kambodscha","cm":"Kamerun","ca":"Kanada","cv":"Kap Verde","ky":"Cayman Inseln","cf":"Zentralafrikanische Republik","td":"Tschad","cl":"Chile","cn":"China","co":"Kolumbien","km":"Comoros","cg":"Kongo","ck":"Cook Inseln","cr":"Costa Rica","ci":"Elfenbeinküste","hr":"Kroatien","cu":"Kuba","cz":"Tschechien","dk":"Dänemark","dj":"Djibouti","do":"Dominikanische Republik","tp":"Osttimor","ec":"Ecuador","eg":"Ägypten","sv":"El Salvador","gq":"Äquatorial Guinea","er":"Eritrea","ee":"Estland","et":"Äthiopien","fk":"Falkland Inseln","fo":"Faroe Inseln","fj":"Fiji","fi":"Finland","fr":"Frankreich","gf":"Französisch Guiana","pf":"Französisch Polynesien","ga":"Gabon","gm":"Gambia","ge":"Georgien","de":"Deutschland","gh":"Ghana","gi":"Gibraltar","gr":"Griechenland","gl":"Grönland","gd":"Grenada","gp":"Guadeloupe","gu":"Guam","gt":"Guatemala","gn":"Guinea","gy":"Guyana","ht":"Haiti","va":"Vatikan","hn":"Honduras","hu":"Ungarn","is":"Island","in":"Indien","id":"Indonesien","ir":"Iran","iq":"Irak","ie":"Irland","il":"Israel","it":"Italien","jm":"Jamaika","jp":"Japan","jo":"Jordanien","kz":"Kasachstan","ke":"Kenia","ki":"Kiribati","kw":"Kuwait","kg":"Kirgistan","la":"Laos","lv":"Lettland","lb":"Libanon","ls":"Lesotho","li":"Liechtenstein","lt":"Litauen","lu":"Luxemburg","mo":"Macau","mk":"Mazedonien","mg":"Madagaskar","mw":"Malawi","my":"Malaysia","mv":"Malediven","ml":"Mali","mt":"Malta","mr":"Mauretanien","mu":"Mauritius","yt":"Mayotte","mx":"Mexiko","fm":"Mikronesien","md":"Moldavien","mc":"Monaco","mn":"Mongolei","ms":"Montserrat","ma":"Marokko","mz":"Mosambik","mm":"Myanmar","na":"Namibia","nr":"Nauru","np":"Nepal","nl":"Niederlande","nz":"Neuseeland","ni":"Nicaragua","ne":"Niger","ng":"Nigeria","nu":"Niue","nf":"Norfolk Inseln","kp":"Nord Korea","no":"Norwegen","om":"Oman","pk":"Pakistan","pw":"Palau","pa":"Panama","pg":"Papua Neu Guinea","py":"Paraguay","pe":"Peru","ph":"Philippinen","pl":"Polen","pt":"Portugal","pr":"Puerto Rico","ro":"Rumänien","ru":"Russland","rw":"Ruanda","ws":"Samoa","sm":"San Marino","sa":"Saudi-Arabien","sn":"Senegal","sc":"Seychellen","sl":"Sierra Leone","sg":"Singapur","sk":"Slovakei","sb":"Solomon Inseln","so":"Somalia","za":"Südafrika","kr":"Südkorea","es":"Spanien","lk":"Sri Lanka","sd":"Sudan","sr":"Suriname","sz":"Swasiland","se":"Schweden","ch":"Schweiz","sy":"Syrien","tw":"Taiwan","tj":"Tadschikistan","tz":"Tansania","th":"Thailand","tg":"Togo","to":"Tonga","tt":"Trinidad und Tobago","tn":"Tunesien","tr":"Türkei","tm":"Turkmenistan","tv":"Tuvalu","ug":"Uganda","ua":"Ukraine","ae":"Vereinigte Arabische Emirate","gb":"Vereinigtes Königreich","us":"Vereinigte Staaten von Amerika","uy":"Uruguay","uz":"Usbekistan","vu":"Vanuatu","ve":"Venezuela","vn":"Vietnam","vg":"Virgin Islands","eh":"Westsahara","ye":"Jemen","yu":"Jugoslavien","zr":"Zaire","zm":"Sambia","zw":"Simbabwe"},"upload":{"errors":{"browserCannotPlayAudio":"Dein Browser kann diese Audio-Daten nicht abspielen.","youCanFindItHere":"Du kannst sie hier finden."},"meta":{"displayName":"Bezeichnung","displayNamePlaceholder":"Optionale Bezeichnung","description":"Beschreibung","descriptionPlaceholder":"Optionale Beschreibung"}},"uppy":{"selectToUpload":"Dateien zum Hochladen auswählen","closeModal":"Fenster schließen","upload":"Upload","browse":"Auswählen","dropPaste":"Datei hier Ablegen, Kopieren oder {browse}","error":{"global":{"title":"Hochladen fehlgeschlagen","description":"Das Hochladen der ausgewählten Datei(en) schlug leider fehl.\n Bitte versuche es erneut."},"upload":{"title":"Hochladen der Datei fehlgeschlagen","description":"Das Hochladen der Datei ist leider fehlgeschlagen.\n Bitte versuche es erneut."}}}}

/***/ }),

/***/ "y1Aq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// myprofile/static/js/app.b871b3beb2c96f6a2dde.js